export default {
    "accountValidateMsg" : "영문,숫자,“.”,“_”,“@” 포함. 6-30글자 제한. 첫 글자는 숫자나 영문이어야 합니다",
    "storeSuccess" : "충전 성공",
    "editAccountTips" : "정확한 계정을 입력하세요",
    "editPwdTips" : "정확한 비밀번호를 입력하세요",
    "editRepeatPwdTips" : "비밀번호를 재입력하세요",
    "pwdRepeatTips" : "입력하신 비밀번호가 일치하지 않습니다",
    "changePwdSucc" : "비밀번호 변경 성공",
    "bindEmail" : "이메일 연동",
    "verifyEmail" : "계정 보안 인증",
    "errorVrifyCodeTips" : "잘못된 인증코드입니다",
    "slectQuessionTips" : "보안문제를 선택하세요",
    "answerTips" : "정답 입력",
    "twoAnswerTips" : "설정한 보안문제 중 2개를 선택하여 정답을 입력하세요",
    "realNameValidateTips" : "이름을 입력하세요(4-60글자 제한)",
    "phoneValidateTips" : "휴대전화 번호를 입력하세요(6-18숫자 제한)",
    "areaSelectTips" : "정확한 국가 및 지역을 선택하세요",
    "iDCardValidataTips" : "주민등록번호를 입력하세요(1-60숫자 제한)",
    "changeProfileSucc" : "정보 변경 성공",
    "editVrfCodeTips" : "인증코드를 입력하세요",
    "securityQuestionTips" : "보안문제를 설정하세요. 비밀번호를 잃어버릴 경우,  보안문제를 통해 비밀번호를 재설정할 수 있습니다",
    "validateQuessionTips" : "문제 2개를 선택하여 인증을 완료하면 보안문제를 재설정할 수 있습니다",
    "originPwd" : "현재 비밀번호 입력하세요",
    "newPwd" : "새로운 비밀번호 입력하세요",
    "changePwdSuccess" : "비밀번호가 변경됐습니다. 로그인하세요",
    "accountName" : "계정을 입력하세요",
    "password" : "비밀번호 입력하세요",
    "repeatPassword" : "비밀번호를 다시 한 번 입력하세요",
    "findPwdTips" : "계정을 입력하세요",
    "submit" : "제출",
    "send" : "보내기",
    "modify" : "수정",
    "haveAgree" : "동의",
    "and" : "과",
    "privacyPolicy" : "개인정보 처리방침",
    "completeness" : "프로필 완성도",
    "gender" : "성별",
    "male" : "남",
    "female" : "녀",
    "birthday" : "생일",
    "phone" : "연락처",
    "region" : "국가/지역",
    "ID" : "여권번호 또는 주민등록번호",
    "accountSetting" : "계정 설정",
    "upgrade" : "계정 업그레이드",
    "profile" : "프로필",
    "changePassword" : "비밀번호 변경",
    "securityQuestion" : "보안 질문 설정",
    "creatework_headerTitle" : "문의하기",
    "mylist_headerTitle" : "내 문의",
    "bindEmailTips" : "자주 쓰는 메일 주소를 적어 주세요. 비밀번호 분실할 경우, 해당 메일을 통해 비밀번호 찾을 수 있습니다",
    "verifyEmailTips" : "새 기기 또는 비정상적인 환경에서 로그인된 것을 감지했습니다. 계정 자산 보호를 위해 본인 인증을 완료해 주세요.",
    "enterEmailVrfcationTips" : "받은 인증코드를 입력하세요",
    "cancel" : "취소",
    "bindTps" : "계정 연동을 설정하여 다른 기기에서도 플레이 할 수 있습니다",
    "login" : "로그인",
    "logout" : "로그아웃",
    "bind" : "계정연동",
    "feedback" : "문의하기",
    "terms" : "이용약관",
    "tips" : "주의",
    "debindTips" : "연동 해제할 시, 계정의 데이터가 삭제될 수 있습니다. 해제 하시겠습니까?",
    "debindText" : "연동 해제",
    "guestSwitchTips" : "사용 중인 게스트 계정이 있습니다. 로그인 후 게스트 계정이 분실됩니다. 로그인하시겠습니까?",
    "register" : "회원 가입",
    "realName" : "이름",
    "enterEmailTips" : "메일 주소를 입력하세요",
    "emailVAlidateMsg" : "잘못된 메일 주소입니다",
    "editEmaileTips" : "메일을 입력하세요",
    "checkServiceTips" : "서비스 이용약관 및 개인정보보호정책을 읽고 동의하세요",
    "brithdayValidateTips" : "정확한 생일을 선택하세요",
    "facebookValidateTips" : "페이스북 계정을 입력하세요(1-60글자 제한)",
    "eritOriginPwdTips" : "사용 중인 비밀번호를 입력하세요",
    "submitSuccess" : "제출 완료",
    "rebindEmail" : "메일 주소 변경",
    "bindEmailSuccess" : "메일을 연동했습니다.\$email</br>연동하신 메일로 인증한 후 메일 주소를 재설정할 수 있습니다",
    "reSetSecurityQuessoon" : "보안문제를 설정하였습니다.<br/><br/>다르는 문제를 선택하고 인증을 완료한 후에 문제를 초기화할 수 있습니다",
    "canotModifyTips" : "개인 정보를 제출한 후에 변경할 수 없습니다. 제출하시겠습니까?",
    "rebindEmailTips" : "메일 주소 \$email,인증코드 발급을 터치한 후 인증코드를 입력하세요",
    "reGetVrfCode" : "인증코드 발급",
    "findPwdWayTips" : "비밀번호 찾기 방식을 선택하세요",
    "emailWay" : "보안 메일",
    "emailWayTips" : "비밀번호를 재설정할 수 있는 인증 메일 발송해 드리겠습니다",
    "quessionWay" : "보안문제",
    "quessionWayTips" : "설정한 보안문제를 맞추면 비밀번호를 재설정할 수 있습니다",
    "resetPwdBtn" : "비밀번호 초기화",
    "lastStep" : "이전",
    "sendEmailTips" : "인증 메일로 \$email 확인 메일을 보내 드렸습니다.<br>받으신 인증코드를 입력해주세요",
    "setNewPwdTips" : "축하합니다!<br>비밀번호를 재설정할 수 있습니다. 지금 바로 비밀번호를 입력하세요!",
    "termsOfUse" : "이용약관",
    "copy_success" : "복사 성공",
    "creatework_create" : "문의 분류",
    "creatework_createHolder" : "문의 분류를 선택해 주세요",
    "creatework_title" : "제목",
    "creatework_titleHolder" : "제목을 입력하세요",
    "creatework_detail" : "문의 내용",
    "creatework_detailHolder" : "200자 내로 문의 내용을 작성해 주세요",
    "creatework_uploadTips" : "5mb이하의 jpg/png문서만 올릴수 있습니다",
    "creatework_selectBox_selectTile" : "문의 분류",
    "creatework_goGame" : "돌아가기",
    "creatework_history" : "문의 내역",
    "mylist_noYet" : "최근 문의하신 내역이 없습니다",
    "mywork_solved" : "문제가 해결 되셨나요?",
    "mywork_service" : "고객센터 평점주기",
    "mywork_messageHolder" : "메세지를 입력하세요",
    "mywork_score" : "평점을 선택하세요",
    "mywork_confirm" : "확인",
    "creatework_selectBox_selectList3" : "기타 문의",
    "creatework_selectBox_selectList2" : "계정 문의",
    "close" : "닫기",
    "creatework_gameHolder" : "게임 선택",
    "creatework_serverHolder" : "서버를 선택하세요",
    "contactService" : "고객센터",
    "FAQ" : "FAQ",
    "creatework_game" : "게임：",
    "creatework_server" : "서버：",
    "creatework_role" : "캐릭터：",
    "selectRoleName" : "캐릭터 선택",
    "creatework_noRole" : "캐릭터 없음",
    "creatework_noGame" : "게임 리스트가 비어 있습니다",
    "creatework_noServer" : "서버 리스트가 비어 있습니다",
    "termText" : "{mainHost}의",
    "backLogin" : "뒤로",
    "creatework_roleHolder" : "캐릭터를 선택하세요",
    "findPwdFailTips" : "보안 문제과 보안 메일이 설정되어 있지 않습니다. 고객센터에 문의하세요",
    "payMall" : "충전 상점",
    "selectPayment" : "금액 선택",
    "plzSelectPayWay" : "충전 수단를 선택하세요",
    "gainPlus" : "보너스",
    "gainMorePlus" : "추가 보너스",
    "gainMostPlus" : "최고 보너스",
    "plzSelectPayType" : "충전 방식을 선택하세요",
    "roleName" : "캐릭터명",
    "payWay" : "결제 수단",
    "plzSelectOtherWay" : "기타 결제 수단",
    "payment" : "결제 금액",
    "compensateTips" : "상품 가격 초과 시, 초과한 부분을 \$gameCode로 돌려드립니다",
    "extaGain" : "보너스",
    "gameGold" : "게임 머니",
    "compensate" : "보상",
    "payWayPlus" : "수단 보너스",
    "neddPay" : "결제 금액",
    "submitOrder" : "주문하기",
    "screenshotTips" : "팁: 주문 내역을 캡쳐하시면 추 후 문제 발생시 더 빠르게 처리할 수 있습니다",
    "storeFail" : "충전 실패",
    "storeFailTips" : "죄송합니다. 충전을 재시도 하시거나 고객센터로 연락해주시기 바랍니다",
    "storeAcceptance" : "처리중",
    "storeSuccessTips" : "충전 성공 후, 15분내로 처리되오니 게임에서 확인하시기 바랍니다",
    "orderNumber" : "주문 번호",
    "buyProduct" : "충전 상품",
    "transactionAmount" : "거래 금액",
    "failReason" : "실패 원인",
    "payOntherORder" : "한번 더 충전하기",
    "reStore" : "충전 다시하기",
    "confirm" : "확인",
    "switch" : "계정 변경",
    "completeTips" : "개인 정보를 작성해주세요. 다음 정보는 <mark class=\"yellowMarkColor\">작성 후 수정이 불가능합니다.</mark>.계정을 잃어버리실 경우에는 고객센터에 본인의 개인정보를 정확히 제공하면 계정을 되찾으실 수 있습니다",
    "creatework_selectBox_selectList0" : "게임 문제",
    "creatework_selectBox_selectList1" : "결제 문제",
    "creatework_selectBox_selectList4" : "번역 문제",
    "mywork_solvedText" : "문제 해결",
    "browserPayErrBtnText" : "오류가 발생했습니다",
    "browserPaySucBtnText" : "결제 완료",
    "browserPayingTips" : "외부 결제 수단을 이용하고 있습니다. <br/>결제 완료 후 페이지를 닫을 수 있습니다",
    "price_list_empty" : "선택할 수 있는 금액이 없습니다",
    "pointCardTips" : "주의 : \$paymentAmount 상당한 게임머니만 구매할 수 있습니다",
    "forgetPwd" : "비밀번호 되찾기",
    "payCenter" : "플랫폼 충전센터",
    "willGet" : "획득내용",
    "goods" : "아이템",
    "discount" : "추가 증정",
    "payDiscount" : "결제 보상",
    "payDiscountTips" : "아이템 가격을 초과할 경우 결제 보상이 있습니다",
    "hasQuestionPlease" : "의문사항이 있으시면",
    "pwdValidateMsg" : "비밀번호는 6~20글자 이내여야합니다",
    "payWayPlusC" : "수단 보너스",
    "fwtk" : "서비스 약관",
    "yszc" : "개인정보 취급 방침",
    "exchange" : "쿠폰등록",
    "remember" : "기억하기",
    "thirdInfo" : "계정 규칙 설명",
    "thirdInfoContent" : "게임 내 유저센터에서 계정을 연동하시고 연동한 계정으로 로그인하시기 바랍니다.",
    "unLink" : "해당 방식을 지원하지 않습니다",
    "favour" : "찜하기",
    "goStoreTip" : "충전 페이지로 이동하세요",
    "go" : "가기",
    "otherLogin" : "다른 로그인 수단",
    "qrCodeTip" : "QR코드를 스캔하고 시작하세요~",
    "favourTip" : "웹브라우저 북마크에 추가해놓으세요~",
    "share" : "공유하기",
    "landscapeTip" : "가로 모드를 이용해주세요",
    "leaveTip" : "정말로 게임을 나가시겠습니까?",
    "selectRole" : "캐릭터를 선택하세요",
    "selectMoney" : "구매 도구 선택",
    "seletGameInfoFirst" : "게임을 선택하세요",
    "lowerIE" : "IE 브라우저를 업그레이드하여 이용해주세요.",
    "linkTermText" : "{mainHost} 플랫품의 [서비스 이용약관] 및 [개인정보취급방침]에 동의합니다",
    "download" : "다운로드",
    "favourAndDownloadTip" : "브라우저에 저장하거나 컴퓨터에 설치해주세요.",
    "payReward" : "충전 혜택",
    "hasEqualReward" : "2배 첫충전 등 충전 혜택을 1번만 획득 가능합니다.",
    "payBtnText" : "결제",
    "storeHoaveReward" : "충전 보너스",
    "showMorePayWay" : "기타 결제 방식",
    "needPaymentCount" : "결제 금액",
    "orderDetail" : "주문 내역",
    "selectPayWayPlz" : "결제 방식을 선택해주세요",
    "countryCode" : "국가 코드",
    "deleteaccount_title1" : "계정 정보 삭제",
    "deleteaccount_title2" : "계정 삭제 요청",
    "deleteaccount_step1_1" : "개인정보 도용 등으로 인한 계정삭제를 방지하기 위해 유저님의 계정이 일시정지 처리되며,  14일 후 계정 및 유저님의 개인정보가 영구적으로 삭제됩니다.",
    "deleteaccount_step1_2" : "14일이 경과하기 전까지 아래 사이트를 방문해 계정 삭제를 취소할 수 있으나",
    "deleteaccount_step1_3" : "14일이 경과하면 계정과 모든 정보가 영구적으로 삭제되어 정보를 가져올 수 없습니다.",
    "deleteaccount_step1_4" : "계정을 삭제하시겠습니까?",
    "deleteaccount_step2_1" : "계정 및 계정 내 모든 캐릭터 정보를 삭제하시겠습니까?",
    "deleteaccount_step2_2" : "입력창에 Delete를 입력해 삭제 작업을 완료해주세요.",
    "deleteaccount_step3" : "14일 후 계정 및 유저님의 개인정보가 영구적으로 삭제됩니다.",
    "accountrecovery_note" : "알림:",
    "accountrecovery_tips" : "계정 일시정지 기간에만 계정삭제를 취소할 수 있습니다.",
    "accountrecovery_Submitted2" : "취소 요청을 성공적으로 제출했습니다.\n잠시 후에 해당 계정 상태가 정상화됩니다.",
    "accountrecovery_Failed" : "제출 실패",
    "accountrecovery_Failed_1" : "계정 상태가 정상입니다.",
    "accountrecovery_Failed_2" : "캐릭터 정보를 조회할 수 없습니다. 다시 입력해주세요.",
    "accountrecovery_success" : "계정 복구 완료",
    "account_normal" : "정상적인 계정. 복구 불가",
    "account_unablerestore" : "탈퇴 계정. 복구 불가",
    "accountrecovery_roleHolder" : "캐릭터명",
    "accountrecovery_headerTitle" : "계정 삭제 취소",
    "guideTitle" : "Your purchase is not successful. Please contact our customer service.",
    "accountFix" : "계정 회복",
    "inputAccount" : "회복할 계정을 입력하세요",
    "applyForAccountFix" : "계정 회복 신청",
    "nonEnterItem" : "미입력 항목：회원가입 시간, 기기 GPID/IDFA, 기기 모델명, 여권 혹은 신분증 번호, 이메일을 먼저 입력하세요",
    "resetOT" : "시간 초과. 다시 제출하세요",
    "addOT" : "보충 자료 시간 초과. 다시 제출하세요",
    "errorPwd" : "비밀번호는 반드시 6-20글자여야하며 영문, 숫자, \".\", \"_\", \"@\"가 포함됩니다",
    "verifyAccount" : "계정 정보 부족. 재인증하세요",
    "selectRegisterTime" : "가입 날짜를 선택해 주세요",
    "enterBindEmail" : "연동 메일을 정확히 입력해 주세요.",
    "enterUsedPhoneType" : "자주 사용하는 휴대폰 모델을 입력하세요",
    "enterIdfaGpid" : "기기 GPID/IDFA를 입력하세요",
    "enterContactEmail" : "올바른 이메일을 입력하세요",
    "confirmTermsPrivacy" : "서비스 약관과 개인정보 취급 방침에 동의해주세요",
    "enterRechargeRemark" : "충전 기록을 입력하세요",
    "uploadImg" : "신분증 스캔본을 업로드하세요",
    "selectIDType" : "신분증 유형을 선택하세요",
    "enterIDNum" : "여권 번호 혹은 신분증 번호를 입력하세요",
    "enterIP" : "회원가입한 IP를 입력하세요",
    "enterQueryNum" : "조회 번호를 입력하세요",
    "enterQueryPwd" : "조회 비밀번호를 입력하세요",
    "errorQueryItem" : "조회 번호 혹은 조회 비밀번호 오류. 다시 입력하세요",
    "enterPassword" : "새로운 비밀번호를 입력하세요",
    "enterPasswordAgain" : "새로운 비밀번호를 재입력하세요",
    "enterPasswordNonSame" : "비밀번호가 다릅니다",
    "enterEmail" : "이메일을 입력하세요",
    "sendSuccess" : "이메일 발송 성공",
    "enterCode" : "인증코드를 입력하세요",
    "errorCode" : "인증코드 오류",
    "selectQuest" : "보안 문제를 선택하세요",
    "enterAnswer" : "답을 선택하세요",
    "selectDifferQuest" : "보안 문제 3개를 선택하고 답을 선택하세요",
    "addSuccess" : "자료 입력 성공",
    "picFormt" : "이미 파일은 JPG, PNG혹은 GIF만 가능합니다",
    "countdownBefore" : "정보 재설정 유효기간:",
    "countdownAfter" : "（00:00:00에 링크를 사용할 수 없으며 계정 회복을 재신청해야합니다）",
    "uploadDone" : "업로드 성공",
    "uploadFail" : "업로드 실패",
    "applySuccess" : "신청 성공",
    "applyFailed" : "신청 실패",
    "resetQuestAlterFailed" : "보안 문제 수정 실패",
    "resetQuestError" : "데이터 입력 오류",
    "resetQuestNone" : "주문이 없습니다",
    "resetQuestAltered" : "보안 문제를 수정한 기록이 있습니다",
    "illegalOperation" : "불법 작업",
    "queryNotExist" : "조회 번호가 없습니다",
    "queryPasswordError" : "조회 비밀번호 오류",
    "auditing" : "심사중",
    "notPass" : "심사 실패",
    "suppleInformation" : "보충 자료",
    "suppleInformationUnHandle" : "보충 자료 제출 성공. 고객센터 처리 중",
    "suppleInformationTimeout" : "자료 보충 기간 초과",
    "repairedAccountSuccess" : "계정 회복 완료",
    "repairedAccountLost" : "계정 회복 작업 실패",
    "loginStateNone" : "미접속 혹은 세션이 만료되었습니다",
    "repairedAccountTimeout" : "계정 회복 기간 초과",
    "changePasswordSucc" : "비밀번호 수정 성공",
    "emailSendFailed" : "이메일 발송 실패",
    "emailSendLimit" : "오늘 더 이상 해당 메일을 사용할 수 없습니다",
    "repairedAccountTimeout2" : "불법 작업 계정 회복 시간 만료",
    "emailCodeSended" : "메일 인증코드 발송 완료",
    "alterSuccess" : "수정 성공",
    "questionAlterSuccess" : "보안 문제 수정 성공",
    "username" : "계정을 입력해 주세요.",
    "code" : "인증번호를 입력해주세요.",
    "selectServiceType" : "원하는 서비스를 선택해 주세요.",
    "submitForm" : "양식을 작성하여 계정을 회복하세요",
    "apply" : "복구 신청",
    "reviewApplicationStatus" : "복구 진행도 조회",
    "instantReviewOfTheStatus" : "계정 복구 진행도 실시간 조회",
    "reviewStatus" : "진행도 조회",
    "backToLogin" : "로그인 페이지로 이동",
    "previous" : "이전",
    "applyDesc" : "다음 항목을 최대한 다 작성하셔야 더 빠른 처리가 가능합니다. *표시가 된 항목은 필수 작성 항목이며 계정에 해당 설정을 하지 않았으면 \'없음\'이라고 작성하시면 됩니다.",
    "additionalServices" : "부가 서비스",
    "resetSecurityEmail" : "보안 메일 리셋",
    "resetSecurityQuest" : "보안 문제 리셋",
    "registrationDate" : "가입 시간",
    "month" : "월",
    "year" : "년",
    "emailBound" : "연동한 이메일을 입력하세요",
    "modelNumber" : "휴대폰 모델명을 입력해 주세요.",
    "deviceName" : "휴대폰 모델명을 입력해 주세요.",
    "provideRecharge" : "상세한 충전 기록(충전 방식, 시간, 금약 등 주문 번호와 거래 번호)를 입력하세요",
    "selectCountry" : "지역 선택",
    "passportID" : "여권 혹은 신분증",
    "upload" : "업로드",
    "del" : "삭제",
    "pleaseUpload" : "신분증 스캔본을 업로드하세요(20MB미만)",
    "uploadAgain" : "재업로드",
    "enterDesc" : "계정이 본인 계정임을 증명할 증거들이 있다면 여기 입력하세요",
    "contactEmail" : "메일 주소",
    "applyNoteAttr" : "안내 :",
    "applyNoteDate" : "이번 문제에 대한 진도와 결과를 받을 수 있는 이메일을 입력하세요",
    "agree" : "동의합니다.",
    "UJOYTerms" : "서비스 이용약관",
    "privacy" : "개인정보취급정책",
    "reviewStatusOfAccountFix" : "회복 진도 조회",
    "enterReviewID" : "조회번호를 입력하세요",
    "enterReviewPwd" : "조회 비밀번호를 입력하세요",
    "review" : "조회",
    "reviewNoteAttr" : "안내 :",
    "reviewNoteData" : "만약 조회 번호와 조회 비밀번호를 잊어버리셨다면 입력하신 메일에서 확인할 수 있습니다",
    "haveResetInfo" : "정보가 갱신되었습니다",
    "resetProfile" : "정보 갱신",
    "desc" : "축하드립니다! 심사가 통과되었습니다. 정보를 다시 설정해 주세요.",
    "resetAccountDesc" : "참고: 계정 잠금을 해제하려면 아래 모든 재설정 항목을 완료해야 합니다.",
    "changePwd" : "비밀번호 변경",
    "resetPwd" : "비밀번호를 갱신해 주세요",
    "reset" : "변경",
    "enterNewPwd" : "신규 비밀번호를 입력해 주세요.",
    "confirmNewPwd" : "비밀번호를 다시 한번 입력해 주세요.",
    "successResetPwd" : "비밀번호가 변동되었습니다.",
    "bindSecurityEmail" : "보안 메일 설정",
    "resetPwdDesc" : "비밀번호이 분실됐거나 계정이 해킹당했을 경우, 보안 문제를 통해 계정을 되찾을 수 있습니다.",
    "bindCommon" : "연동",
    "sendCommon" : "발송",
    "enterVcode" : "수신한 인증번호를 입력해 주세요.",
    "successResetEmail" : "보안 메일이 리셋되었습니다.",
    "resetQuest" : "보안 문제 리셋",
    "resetQuestDesc" : "비밀번호이 분실됐거나 계정이 해킹당했을 경우, 보안 문제를 통해 계정을 되찾을 수 있습니다.",
    "successResetQuest" : "보안 문제가 리셋되었습니다.",
    "hide" : "접기",
    "addRegisterTime" : "가입 시간:",
    "modelNum" : "IDFA/GPID를 입력하세요",
    "registrationIP" : "회원가입한 IP를 입력하세요；",
    "addRechargeRecord" : "충전 기록을 입력하세요；",
    "serviceReply" : "고개센터 답장：",
    "addDataLimitTime" : "자료 보충 유효기간：",
    "addMoreInfo" : "더 많은 자료를 보충하세요",
    "applicationSubmit" : "신청 제출 성공",
    "underReviewStatus" : "자료를 심사하고 있습니다. 하루(근무일)내로 답변이 갈 예정이며 다음 방법으로 진도를 확인할 수 있습니다：",
    "reviewID" : "조회 번호:",
    "reviePwd" : "조회 비밀번호:",
    "enterReviewIDNPwd" : "계정 회복 진도 조회 화면에서 조회 번호와 조회 비밀번호를 입력하면 현재 처리 진행상황을 확인할 수 있습니다",
    "homepage" : "홈페이지로 돌아가기",
    "checkEmailAttr" : "알림:",
    "checkEmailData" : "만약 조회 번호와 조회 비밀번호를 잊어버리셨다면 입력하신 메일에서 확인할 수 있습니다",
    "underReview" : "자료 심사중",
    "underReviewReply" : "자료를 심사하고 있습니다. 잠시만 기다려 주세요!",
    "failed" : "심사 실패",
    "reason" : "원인: 제공하신 ###(이)가 심사에 통과하지 못했습니다. 정확한 정보를 제공해주시면 최대한 빨리 처리해드리겠습니다. 감사합니다!",
    "underReviewAdd" : "자료를 심사하고 있습니다. 미입력한 부분이 있으니 최대한 모두 입력해주시기 바랍니다!",
    "addInfoRequired" : "보충 제출 자료:",
    "dateForAddInfo" : "보충 자료 유효기간:",
    "addInfo" : "보충 자료",
    "addInfoSubmit" : "보충 자료 제출 성공! 심사를 대기해주세요",
    "hasBeenRepaired" : "계정 회복 완료",
    "opExpired" : "계정 회복 작업 기간 만료",
    "approved" : "심사 통과",
    "haveSubmitted" : "보충자료가 이미 제출되었습니다",
    "sessionExpired" : "미접속 혹은 세션이 만료되었습니다",
    "submitted" : "제출 성공",
    "addItemRegisterDate" : "연동 이메일 입력；",
    "addItemDeviceNumber" : "GPID/IDFA 입력；",
    "reasonItemPwd" : "신분증 오류；",
    "addItemIDPhoto" : "식별 가능한 유효한 신분증 제출；",
    "idfaTitle" : "IDFA와 안드로이드 GPID확인 방법은?",
    "idfaSubTitle1" : "아이폰 유저의 IDFA확인 방법",
    "idfaSubTitle1Desc1" : "1.appsotre에서 【<em>MyIDFA</em>】다운로드",
    "idfaSubTitle1Desc2" : "2. <em>APP</em>에서 해당 기기의 <em>IDFA</em>확인",
    "idfaSubTitle2" : "안드로이드폰 유저의 GPID확인 방법",
    "idfaSubTitle2Desc1" : "1. 【<em>설정</em>】기능 터치",
    "idfaSubTitle2Desc2" : "2.【<em>설정</em>】에서 【<em>계정</em>】혹은 【<em>계정 동기화</em>】에서 【<em>Google</em>】을 선택하여 터치",
    "idfaSubTitle2Desc3" : "3.【<em>광고</em>】에서 <em>ID</em>확인（다음 이미지 확인）",
    "uploadIDCard" : "신분증 스캔본을 업로드하세요(2MB미만)",
    "uploadTipsBefore" : "M미만의",
    "uploadTipsAfter" : "이미지만 업로드 가능합니다",
    "submitError" : "오류. 신분증 미입력, 계정 입력 오류",
    "applyLimitError" : "하루 신청 제한 횟수 상한 달성",
    "applyDisabled" : "10분에 1회 신청할 수 있습니다",
    "inputDataError" : "데이터를 입력하세요",
    "dataException" : "데이터 오류",
    "picSizeLimit" : "이미지 파일은 5MB를 초과할 수 없습니다",
    "picTypeLimit" : "JPG, PNG, GIF파일만 업로드할 수 있습니다",
    "picNull" : "이미지 파일이 없습니다",
    "alteredPassword" : "비밀번호 변경 기록이 있습니다",
    "inputError" : "입력 오류",
    "pwdChangefailed" : "비밀번호 수정 실패",
    "sendEmailCodeDisabled" : "일정 시간 후에 이메일 인증코드가 발송됩니다",
    "alteredEmail" : "이메일 수정 기록이 있습니다",
    "inputEmailError" : "이메일 입력 오류",
    "operationFailed" : "작업 실패",
    "codeNull" : "인증코드를 입력하세요",
    "findPwd" : "비밀번호 되찾기",
    "findAccountAndPwd" : "계정과 비밀번호 되찾기",
    "usualDeviceNum" : "IDFA/GPID를 입력하세요",
    "usualPhoneNum" : "자주 사용하는 휴대폰 모델을 입력하세요",
    "registerTimeError" : "회원가입 시간 불일치；",
    "bindEMailError" : "연동 이메일 불일치；",
    "rechargeRecordError" : "충전기록 불일치；",
    "registerIPError" : "회원가입 IP주소 불일치；",
    "deviceNumError" : "IDFA/GPID불일치；",
    "deviceModelError" : "휴대폰 모델 불일치；",
    "confirmTerms" : "서비스 이용약관에 동의하세요",
    "applyFixAccount" : "상술한 방법으로 인증이 불가능할 경우 <span>계정 회복</span>을 신청할 수 있습니다.",
    "findPwdByFixAccount" : "해당 계정은 이메일과 보안 문제를 설정하지 않았습니다. 계정 회복으로 비밀번호를 되찾을 수 있습니다.",
    "connectFail" : "Disconnected from Google Services, please try again",
    "h5_favour_has_gift" : "게임을 즐겨찾기에 저장하세요~ 보상을 이미 수령하셨습니다~",
    "h5_favour_get_gift" : "게임을 즐겨찾기에 저장하세요~ 보상은 우편으로 발송되었습니다~",
    "h5_get_gift_fault" : "수령 실패. 잠시 후, 시도하시거나 게임 내 고객센터로 연락주시기 바랍니다.",
    "h5_favour_please_select" : "서버/캐릭터 선택하세요",
    "h5_favour_login_get" : "로그인 후, 즐겨찾기를 진행하셔야 보상이 지급됩니다~",
    "h5_favour_tip" : "게임을 즐겨찾기에 저장하세요~",
    "h5_favour_select_serve" : "Please choose server",
    "h5_favour_select_role" : "Please choose character",
    "store_product_paytype_error" : "선택하신 상품은 해당 경로로 구매하실 수 없습니다. 다른 경로로 구매를 진행해주시기 바랍니다.",
    "SwitchWithThirdWay" : "\${type} 로그인",
    "moreGame" : "더 많은 게임",
    "serviceTitle" : "고객센터",
    "h5_download_login" : "먼저 로그인해주세요!",
    "h5_download_tips" : "클라이언트를 통해 로그인해주세요!",
    "h5_download_repeat_get" : "해당 게임 패키지를 이미 수령했습니다!",
    "h5_download_succ" : "클라이언트를 다운로드하세요!",
    "h5_download_repeat_role" : "이미 연동된 캐릭터입니다.",
    "currentLoginAccount" : "현재 계정 :",
    "fb_canvas_fullscreen" : "전체화면",
    "fb_canvas_website" : "홈페이지",
    "fb_canvas_like_share" : "공유",
    "fb_canvas_service" : "고객센터",
    "fb_canvas_login_fail" : "로그인 실패",
    "fb_canvas_pay_return" : "결제가 취소되었습니다.",
    "fb_canvas_root_tip" : "페이스북 로그인을 승인해 주세요.",
    "h5_popup_title" : "결제 수단",
    "h5_popup_submit" : "결제",
    "h5_popup_last_used" : "이전 결제 수단",
    "h5_popup_quit_tips" : "결제를 취소하시겠습니까?",
    "h5_popup_quit_check" : "예",
    "h5_popup_quit_cancel" : "아니오",
    "h5_popup_currency_sign" : "원",
    "h5_popup_product_empty" : "상품 정보 불러오기 실패. 화면을 갱신하세요.",
    "h5_popup_server_empty" : "서버 리스트 불러오기 실패. 화면을 갱신하세요.",
    "aboutRelevanceAccount" : "Already have an account?",
    "selectLoginType" : "Select a login method",
    "touristDescription" : "If you already have an account, you can log in as a guest and then use the OTP (One-Time Password) feature in the user center to switch accounts. This feature requires the OTP functionality to be set up on your mobile device in the user center.",
    "touristSuggest" : "If you already have an account, you can log in as a guest and then tap the \"Switch Account\" option in the user center. From there, you can log in using a previously bound social media account.",
    "h5_tourist_remenber" : "Remember me for 14 days",
    "account_czsm1" : "1. 계정 이전을 통해 계정 데이터를 새로운 기기로 이전할 수 있습니다. 기기의 운영체제와 상관없이 이전 가능합니다.",
    "account_czsm2" : "2. 계정 이전에 사용할 비밀번호를 설정해야 합니다.",
    "account_czsm3" : "3. 계정을 보호하기 위해 계정 이전을 진행하기 전에",
    "account_wzfdmm" : "대소문자를 구분하여 6~16글자 입력하세요.",
    "account_qzcsrmm" : "비밀번호를 다시 입력하세요.",
    "account_fxyjm" : "이전 코드 발급",
    "account_yjmsm1" : "1. 메인 화면-고객센터-계정 변경에서 계정 이전을 진행할 수 있습니다.",
    "account_yjmsm2" : "2. 이전 코드는 기간 제한이 없습니다.",
    "account_yjmsm3" : "3. 이전 코드당 1회만 사용 가능합니다.",
    "account_yjmsm4" : "4. 계정을 보호하기 위해 이전 코드 관련 정보를 제3자에게 알리지 마시기 바랍니다.",
    "account_fz" : "복사",
    "account_cxfx" : "재발급",
    "account_czsm4" : "계정 연동",
    "account_czsm5" : "을 완료해주시기 바랍니다.",
    "account_yjm" : "이전 코드",
    "account_16wzzj" : "비밀번호의 글자수는 6~16글자로 제한됩니다.",
    "account_qsrzqdyjmhmm" : "정확한 이전 코드와 비밀번호를 입력하세요.",
    "account_yj" : "이전하기",
    "accoun_lcsrdmmbyz" : "입력한 비밀번호가 일치하지 않습니다.",
    "deleteaccount_step3_1" : "에서 계정 삭제를 취소할 수 있습니다.\n신청을 취소하시겠습니까?",
    "account_syyjm" : "1. 이전 코드를 사용하여 게임 데이터를 사용 중인 기기로 이전할 수 있습니다.",
    "account_yjmznsyyc" : "2. 이전 코드당 1회만 사용 가능합니다.",
    "account_sryjm" : "이전 코드 입력하기",
    "account_srmm" : "비밀번호 입력하기",
    "h5_header_gift" : "패키지",
    "h5_award_popup_type" : "보상",
    "h5_award_popup_content" : "아이템",
    "h5_award_popup_code" : "쿠폰 코드",
    "h5_favour_gift_name" : "즐겨찾기 패키지",
    "h5_download_gift_name" : "다운로드 패키지",
    "h5_award_popup_exchange_way" : "교환 방법：게임 메인 화면 오른쪽 하단→더 보기→쿠폰교환",
    "h5_succ_get_gift" : "쿠폰 코드를 획득하셨습니다.",
    "h5_exchange_info_title" : "교환 안내",
    "h5_exchange_info_1" : "교환 방법：게임 메인 화면 오른쪽 하단→더 보기→쿠폰교환",
    "h5_exchange_info_2" : "계정당 다운로드 패키지 1번만 교환할 수 있습니다.",
    "h5_check_gift" : "보상 조회",
    "account_delete_scdqzh" : "현재 계정과 게임 내 모든 데이터를 삭제하시겠습니까?",
    "account_delete_fwq" : "서버",
    "account_delete_zhm" : "캐릭터",
    "account_delete_jshflj" : "캐릭터 되찾기",
    "account_delete_qzyzmdxx" : "(대소문자를 구별해주세요.)",
    "account_delete_jtbcysxx" : "다음 정보를 스크린샷으로 저장하셔서 계정 되찾기에 사용하시기 바랍니다!",
    "deleteaccount_step3_2" : "14일이 경과하면 계정과 모든 정보가 영구적으로 삭제되어 정보를 가져올 수 없습니다.\n\n14일이 경과하기 전까지",
    "h5_guest_login" : "Guest",
    "h5_click_copy" : "",
    "questionnaire_btn" : "questionnaire investigation",
    "h5_header_store_text" : "충전",
    "h5_header_home_text" : "홈페이지",
    "h5_check_gift_list_text" : "보상 확인",
    "yourServer" : "소속 서버",
    "allServer" : "전체 서버",
    "h5_header_screen" : "풀스크린",
    "h5_verticalTip" : "가로모드로 플레이하세요",
    "h5_third_party_login_tips" : "If you want to log in using a social media account (such as Facebook, Google, Twitter, etc.), you can first log in as a guest and then bind your social media account in the user center.",
    "webStoreUidTitle" : "",
    "webStoreUidTips" : "",
    "webStoreUidGuide" : "",
    "webStoreUidInputt" : "",
    "feedbackTips" : "",
    "recentPlay" : "최근 플레이",
    "moreGames" : "더 보기",
    "previousSelect" : "지난 선택",
    "payAgainBtn" : "재충전",
    "packageTypeName" : "패키지",
    "coinTypeName" : "충전",
    "cardTypeName" : "월정액",
    "orderNormal" : "기본",
    "orderPriceUp" : "가격 오름차순",
    "orderPriceDown" : "가격 내림차순",
    "returnSelectRole" : "이전 화면",
    "jiamaInfo" : "보너스 원보/다이아 = 충전 금액*게임 머니(원보/다이아) 환산 비율*보너스 비율\n* 주의사항 : 보너스 원보/다이아는 인게임 충전 이벤트에 포함되지 않으며 VIP 경험치에 누적되지 않습니다.\n* 일부 게임은 전세계에서 운영 중인 게임으로 결제 금액은 달러로 계산됩니다. 문의사항이 있으시면 언제든지 고객센터로 연락하시기 바랍니다.",
    "lastSelectTag" : "지난 선택",
    "onestore_subscribe_manage" : "구독 관리",
    "onestore_subscribe_entrance" : "원스토어 구독 관리",
    "onestore_subscribe_has_expire" : "만료",
    "onestore_subscribe_expire_time" : "만료 기간 : \${year}년 \${month}월 \${day}일",
    "onestore_subscribe_privacy" : "구독과 개인정보",
    "onestore_subscribe_cancel_subscribe" : "구독 취소",
    "onestore_subscribe_info_title" : "구독 정보",
    "onestore_subscribe_option_title" : "구독 옵션",
    "onestore_subscribe_do_not_subscribe" : "지금 안 함",
    "onestore_subscribe_get_role_fail" : "구독 정보를 불러오기에 실패했습니다. 게임에서 다시 페이지를 열어주시기 바랍니다.",
    "onestore_subscribe_later" : "나중에",
    "onestore_subscribe_confirm" : "확인",
    "onestore_subscribe_confirm_cancel" : "취소 확인",
    "onestore_subscribe_popup_tip" : "지금 취소를 확인하여 구독을 종료해도 \${year}년 \${month}월 \${day}일 전까지는 계속 구독 항목을 이용할 수 있습니다.",
    "onestore_subscribe_detail_tip" : "구독이 만료되기 1일 전까지 취소하지 않으면 \${year}년 \${month}월 \${day}에 선택하신 옵션에 따라 \${prices}/1개월의 가격으로 구독이 자동 갱신됩니다.",
    "onestore_subscribe_expired_tip" : "만료된 구독은 게임 상점에서 재구독하셔야 합니다.",
    "onestore_subscribe_goon_sub" : "\${year}년 \${month}월 \${day}일에 갱신 예정",
    "onestore_subscribe_has_cancel_tip1" : "구독을 취소했습니다. \${year}년 \${month}월 \${day}일 전까지 계속 해당 구독 항목을 이용할 수 있습니다.",
    "onestore_subscribe_has_cancel_tip2" : "재구독을 원하시면 게임 상점에서 다시 구독신청을 해주세요.",
    "onestore_subscribe_cancel_fail" : "구독 취소 실패. 잠시 후 다시 시도하세요.",
    "onestore_subscribe_cancel_fail_title" : "구독 취소",
    "apple_deleteaccount" : "계정 삭제",
    "apple_deleteaccount_title" : "계정 삭제 신청",
    "apple_deleteaccount_step1_1" : "다음 내용을 자세히 읽어주세요:",
    "apple_deleteaccount_step1_2" : "계정 삭제를 신청하시면 계정이 14일 동안 정지 상태로 보호됩니다.",
    "apple_deleteaccount_step1_3" : "기간 동안 계정 삭제 신청을 취소하지 않으면 14일이 지난 뒤 해당 계정이 <span class=\"highlight\">영구적으로 삭제</span>됩니다. 계정 삭제 후에는 해당 계정으로 게임에 접속할 수 없고 모든 데이터가 지워지며 복구가 불가능하게 됩니다.",
    "apple_deleteaccount_step1_4" : "SNS 계정 연동 해제를 원하신다면 고객센터에 문의해서 연동을 해제한 뒤 계정 삭제를 신청하시기 바랍니다. 그렇지 않을 경우 계정이 삭제된 후 연동된 SNS 계정으로 게임에 접속할 수 없게 됩니다.",
    "apple_deleteaccount_step1_5" : "<span class=\"highlight\">환불을 원하시는 경우, 계정이 삭제되기 전에 고객센터에 연락해 처리</span>하시고, 계정이 삭제되기 전에 모든 게임 자산이 처리되었음을 확인하셔야 합니다.",
    "apple_deleteaccount_step1_6" : "보호 정지 기간 동안 아래 링크로 이동하여 계정 삭제 신청을 취소할 수 있습니다. 링크 주소를 저장해두세요.",
    "apple_deleteaccount_step2_1" : "게임 자산이 모두 처리되었습니까? 아직도 미처리된 게임 자산이 있으면 고객센터에 연락해 처리하신 뒤 계정 삭제를 신청하세요.",
    "apple_deleteaccount_step2_2" : "서버와 캐릭터 정보를 저장해두세요. 계정 복구를 신청할 때 해당 정보가 필요합니다.",
    "apple_deleteaccount_step2_3" : "입력창에 \'Delete\'를 입력하여 삭제 신청을 완료해주세요",
    "apple_deleteaccount_step3_1" : "계정 삭제 신청이 제출되어 다음 계정이 보호 정지되었습니다 :",
    "apple_deleteaccount_step3_2" : "보호 정지 기간은 14일이며 기간에 계정 삭제 취소 요청이 들어오지 않으면 계정이 영구적으로 삭제됩니다.",
    "apple_deleteaccount_step3_3" : "보호 정지 기간 동안 여전히 다음 링크를 터치해 계정 삭제 신청을 취소할 수 있습니다.",
    "apple_deleteaccount_step4_1" : "기존의 계정을 삭제했습니다. 다음 실행 시 계정을 새롭게 생성하여 로그인하세요.",
    "apple_deleteaccount_agree" : "위 내용을 읽었으며 동의합니다.",
    "apple_deleteaccount_server" : "서버",
    "apple_deleteaccount_roleName" : "캐릭터명",
    "copyLink" : "복사하기",
    "copyTextAndImg" : "복사하거나 캡쳐하여 저장하세요",
    "copyLinkAndRoleInfo" : "링크 주소와 캐릭터명 복사하기",
    "hasCopy" : "클립보드로 복사되었습니다.",
    "quickcard_tips" : "신용카드 정보는 암호화되어 World Pay의 보호를 받습니다. 해당 정보는 결제 서비스 최적화 용도로만 사용됩니다.",
    "quickcard_use_new_card" : "새 카드 등록",
    "edit" : "편집",
    "save" : "저장",
    "quickcard_confirm_delete" : "삭제 확인",
    "quickcard_popup_tip" : "삭제 후 해당 신용카드로 결제를 원하시는 경우, \'새 카드 등록\'을 선택하시면 됩니다.",
    "quickcard_result_tip_one" : "결제 화면에서 카드 번호 저장을 선택한 경우, 해당 신용카드 정보는 암호화되어 관리됩니다(**** **** **** 1234).",
    "quickcard_result_tip_two" : "이는 결제 편의성 제고를 위한 것으로 다음 결제 시 카드 번호를 입력 없이 이용하실 수 있습니다.",
    "quickcard_learn_more" : "상세 내용 조회>",
    "quickcard_info_title" : "토큰 저장 설명",
    "quickcard_info_tip_one" : "이용자 데이터 안전 보호를 위해 Visa 및 Mastercard는 새로운 \'토큰 저장\' 기술을 도입하고 토큰 저장과 관련된 거래를 규범화했습니다.",
    "quickcard_info_tip_two" : "웹사이트를 통한 거래 시 귀하의 신용카드 정보(1234 **** **** 1234)는 암호화되어 수집되며, 4년 동안 저장됩니다. 변경사항이 발생할 경우, 웹사이트에 이용약관과 개인정보취급방침이 갱신될 것입니다. 암호화된 신용카드 정보 저장은 결제 편의성 제고를 위한 것으로 다음 결제 시 카드 번호 입력 없이 이용하실 수 있습니다.",
    "search_product" : "검색 상품명",
    "search_price" : "검색 가격",
    "price" : "가격",
    "product_no_found" : "조건에 맞는 상품명/가격이 없습니다",
    "price_no_found" : "조건에 맞는 상품명/가격이 없습니다",
    "search_no_found" : "조건에 맞는 상품명/가격이 없습니다",
    "product" : "상품명",
    "store_tag_hot" : "HOT",
    "store_tag_discount" : "Discount",
    "store_tag_double" : "Double",
    "store_tag_treble" : "Treble",
    "store_tag_sale" : "SALE",
    "store_tag_top_seller" : "TOP SELLER",
    "store_tag_off_10" : "10%OFF",
    "store_tag_off_20" : "20%OFF",
    "store_tag_off_30" : "30%OFF",
    "store_tag_off_40" : "40%OFF",
    "store_tag_off_50" : "50%OFF",
    "store_tag_off_60" : "60%OFF",
    "store_tag_off_70" : "70%OFF",
    "store_tag_off_80" : "80%OFF",
    "store_tag_off_90" : "90%OFF",
    "store_tag_event" : "Event",
    "store_tag_daily" : "Daily",
    "store_tag_weekly" : "Weekly",
    "store_tag_monthly" : "Monthly",
    "subscriptionTypeName" : "subscription",
    "useDoubleSend" : "패키지 2배권사용하다?",
    "doubleSendInfo" : "이번 구매에 패키지 2배권을 사용하셔서 일부 아이템의 획득량이 2배입니다. 우편에서 확인할 수 있습니다!",
    "storeRoleTitle" : "캐릭터를 선택하세요",
    "storeSocialLogin" : "SNS 계정으로 로그인",
    "storeAccountIdLogin" : "계정 ID로 로그인",
    "storeInputId" : "계정 ID를 입력하세요",
    "storeSearch" : "조회",
    "storeSelectProductTitle" : "구매할 아이템 선택",
    "storeInputNameSearch" : "상품명으로 검색",
    "storeInputPriceSearch" : "상품 가격으로 검색",
    "storeNoFindProduct" : "상품을 찾지 못했습니다. 다시 시도하세요.",
    "storePriceUp" : "가격 오름차순",
    "storePriceDown" : "가격 내림차순",
    "storeLookDetail" : "상세 정보",
    "storeChangeProduct" : "상품 변경",
    "storeWelcome" : "어서 오세요",
    "storeLookMore" : "더 보기",
    "storeHasSelect" : "선택한 상품",
    "storeTotal" : "합계",
    "storeExtra" : "보너스",
    "storeProductDetail" : "상품 정보",
    "storeUidGuideStep1" : "「설정」-「더 보기」-「계정」을 터치합니다.",
    "storeUidGuideStep2" : "「계정 ID」를 입력하면 충전이 가능합니다.",
    "storeSelectAndLook" : "캐릭터를 선택해야 상품을 조회할 수 있습니다.",
    "storeSwitchWay" : "로그인 방식 변경",
    "type1" : "일일 특혜",
    "type2" : "영웅",
    "type3" : "전투 장비",
    "type4" : "",
    "type5" : "칩",
    "type6" : "사이보그",
    "type7" : "자원",
    "type8" : "건설 가속",
    "type9" : "희귀 상품",
    "type10" : "연맹",
    "type11" : "다이아",
    "type12" : "부품",
    "type13" : "큐브",
    "type14" : "",
    "type15" : "나노 무기",
    "type16" : "최종 보상",
    "type17" : "",
    "type9999" : "한정 공급",
    "type10000" : "기프트 센터",
    "type10001" : "기념일 이벤트",
    "typeother" : "기타 상품",
    "switchChar" : "캐릭터 변경",
    "howToFindUid" : "계정 ID를 어디서 확인할까요?",
    "choosePayWay" : "결제 방식 선택",
    "new_apple_deleteaccount_stepsub_title" : "구독 자동 연장",
    "new_apple_deleteaccount_stepsub_1" : "귀하의 계정에 구독 자동 연장 서비스를 신청한 항목이 존재합니다. 계정 삭제 이후 자동 결제되는 것을 방지하기 위해 먼저 구독을 취소한 다음 계정을 삭제하시기 바랍니다.",
    "new_apple_deleteaccount_stepsub_2" : "구독 자동 연장 취소하기",
    "new_apple_deleteaccount_stepsub_later" : "나중에",
    "new_apple_deleteaccount_stepsub_now" : "삭제하기",
    "new_apple_deleteaccount_title" : "계정 삭제 신청",
    "new_apple_deleteaccount_step1_1" : "다음 내용을 자세히 읽어주세요:",
    "new_apple_deleteaccount_step1_2" : "계정 삭제를 한 뒤 해당 계정이 <span class=\"highlight\">영구적으로 삭제</span>됩니다. 계정 삭제 후에는 해당 계정으로 게임에 접속할 수 없고 모든 데이터가 지워지며 복구가 불가능하게 됩니다.",
    "new_apple_deleteaccount_step1_3" : "SNS 계정 연동 해제를 원하신다면 고객센터에 문의해서 연동을 해제한 뒤 계정 삭제를 신청하시기 바랍니다. 그렇지 않을 경우 계정이 삭제된 후 연동된 SNS 계정으로 게임에 접속할 수 없게 됩니다.",
    "new_apple_deleteaccount_step1_4" : "<span class=\"highlight\">환불을 원하시는 경우, 계정이 삭제되기 전에 고객센터에 연락해 처리</span>하시고, 계정이 삭제되기 전에 모든 게임 자산이 처리되었음을 확인하셔야 합니다.",
    "new_apple_deleteaccount_step2_1" : "게임 자산이 모두 처리되었습니까? 아직도 미처리된 게임 자산이 있으면 고객센터에 연락해 처리하신 뒤 계정 삭제를 신청하세요.",
    "new_apple_deleteaccount_step2_2" : "입력창에 \'Delete\'를 입력하여 삭제 신청을 완료해주세요. 신청 제출 후 계정을 회복할 수 없습니다.",
    "new_apple_deleteaccount_step2_3" : "입력창에 \'Delete\'를 입력하여 삭제 신청을 완료해주세요",
    "new_apple_deleteaccount_step3_1" : "계정 삭제 신청을 제출하였습니다. 다음 계정와 이용자 데이터가 완전히 삭제되었고 복구가 불가능합니다.",
    "new_apple_deleteaccount_step3_2" : "게임 플레이를 원하시는 경우, 새로운 계정을 생성하세요.",
    "new_apple_deleteaccount_step4_1" : "기존의 계정이 삭제되었습니다. 다음부터 신규 계정으로 로그인됩니다.",
    "currencyTypeName" : "통용 화폐",
    "has_select_product" : "선택한 상품 :",
    "n_product" : "상품 \${n}개",
    "look_detail_product" : "전체보기",
    "limit_buy_product" : "해당 상품은 최대 \${n}개 구매할 수 있습니다.",
    "limit_order" : "주문당 최대 \${n}개의 상품을 구매할 수 있습니다.",
    "limit_order_remove_tip" : "주문에 구매할 수 없는 구매 한정 상품이 있습니다. 해당 상품을 삭제하시겠습니까?",
    "paytype_limit" : "일부 상품은 해당 결제 방식을 지원하지 않아 다른 결제 방식을 선택하거나 해당 상품을 단독으로 구매하시기 바랍니다.",
    "check_remove_cart" : "삭제 확인",
    "remove_cart" : "삭제",
    "confirm_product" : "확인",
    "select_paytype" : "결제 방식 선택",
    "cart_is_empty_tip" : "장바구니가 비어 있습니다. 우선 상품을 선택하세요.",
    "thirty_tip" : "30분 내 상품을 지급받지 못하면 고객센터에 연락하시기 바랍니다.",
    "total_n_product" : "상품 수량 : \${n}개",
    "look_detail_of_cart" : "상세 조회",
    "order_detail" : "결제 내역",
    "total_detail" : "수량 :",
    "add_to_cart" : "장바구니",
    "back_to_select" : "돌아가기",
    "fail_and_later" : "상품 정보 오류 발생. 잠시 후 다시 시도하세요.",
    "nextStep" : "확인",
    "pnsGameName" : "퍼즐 오브 Z",
    "enterOfficial" : "공식 사이트",
    "visitorLogin" : "게스트",
    "tokenLogin" : "OTP",
    "fbLogin" : "페이스북",
    "googleLogin" : "구글플레이",
    "twitterLogin" : "트위터",
    "vkLogin" : "VK",
    "agreementTextStart" : "로그인하면 서비스 이용약관과 개인정보처리방침을 읽었으며 동의한 것으로 간주합니다.",
    "userCenter" : "유저 센터",
    "welcomeBack" : "어서 오세요",
    "continueGame" : "게임 시작",
    "officialPay" : "공식 결제 센터",
    "changeAccount" : "계정 변경",
    "back" : "이전",
    "tokenKey" : "OTP 번호",
    "inputUid" : "UID를 입력하세요",
    "inputToken" : "OTP를 입력하세요",
    "inputCkCode" : "인증번호를 입력하세요",
    "enterGame" : "게임 시작",
    "tokenTip" : "OTP로 계정을 안전하게 지키자",
    "howToGetToken" : "OTP 획득 방법",
    "getStep1" : "Step1:설정 - 계정 - 유저 센터를 터치합니다.",
    "getStep2" : "Step2:OTP를 터치합니다.",
    "getStep3" : "Step3:UID를 복사하고 OTP를 입력합니다.",
    "copy" : "복사",
    "lastRefresh" : "다음 갱신 :",
    "second" : "초",
    "immediatelyRefresh" : "바로 갱신",
    "frequently" : "조작이 잦습니다. 잠시 후 다시 시도하세요.",
    "loginFail" : "인증번호를 정확하게 입력하세요.",
    "tokenIntro" : "OTP 사용 방법 :",
    "tokenIntro1" : "1. 유저님의 계정을 안전하게 지키기 위해 OTP 번호는 갱신 후 120초간 유효합니다.",
    "tokenIntro2" : "2. 운영진은 어떠한 경우에도 유저님께 OTP 번호를 요구하지 않습니다. OTP 번호를 다른 사람에게 알려주지 마시기 바랍니다.",
    "nextStep1" : "확인",
    "couponCanUse" : "쿠폰 사용 가능",
    "couponCanNotUse" : "사용 불가 쿠폰",
    "couponHasNoCoupon" : "쿠폰 없음",
    "couponUseTip" : "주문서 당 쿠폰 1장만 사용 가능",
    "couponValidTime" : "유효기간",
    "couponFuilCanUse" : "\${price} \${currency}  이상 주문에 사용 가능",
    "couponNoLimit" : "주문 금액 제한 없음",
    "couponAllProductCanUse" : "모든 상품에 적용",
    "couponPartProductCanUse" : "일부 상품에만 적용",
    "couponPartPaytypeCanUse" : "일부 결제 방식에만 적용",
    "couponOnlyCoinCanUse" : "인게임 화폐 상품에만 적용",
    "couponOnlyDiamondCanUse" : "다이아 상품에만 적용",
    "couponOnlyPackageCanUse" : "패키지에만 적용",
    "couponOnlySubCanUse" : "구독 상품에만 적용",
    "couponOnlyDaibiCanUse" : "코인 상품에만 적용",
    "couponMaxDiscount" : "최대 \${price} \${currency} 까지 할인 가능",
    "couponHasUsed" : "사용됨",
    "couponReductionType" : "정액 할인 쿠폰",
    "couponDiscountType" : "할인 쿠폰",
    "couponUseNow" : "사용하기",
    "couponHasNoSelect" : "쿠폰 미선택",
    "couponHasSelectQuan" : "선택됨",
    "couponSubmitTip" : "*주문서를 제출하면 쿠폰이 즉시 사용됩니다",
    "couponCanUseQuan" : "쿠폰 사용 가능",
    "couponOrderTotal" : "주문 금액",
    "couponHasDiscount" : "할인:",
    "couponPayTotal" : "결제 금액",
    "couponCancel" : "취소",
    "couponConfirm" : "확인",
    "uidLoginName" : "OTP",
    "uidToken" : "OTP 번호",
    "uidInputUid" : "UID를 입력하세요",
    "uidInputToken" : "OTP를 입력하세요",
    "uidInputCode" : "인증번호를 입력하세요",
    "uidTipTitle" : "OTP로 계정을 안전하게 지키자",
    "uidTipHowToGet" : "OTP 획득 방법",
    "uidTipStep1" : "Step1:설정 - 계정 - 유저 센터를 터치합니다.",
    "uidTipStep2" : "Step2:OTP를 터치합니다.",
    "uidTipstep3" : "Step3:UID를 복사하고 OTP를 입력합니다.",
    "uidTipIntro1" : "1. 유저님의 계정을 안전하게 지키기 위해 OTP 번호는 갱신 후 60초간 유효합니다.",
    "uidTipIntro2" : "2. 운영진은 어떠한 경우에도 유저님께 OTP 번호를 요구하지 않습니다. OTP 번호를 다른 사람에게 알려주지 마시기 바랍니다.",
    "couponMyQuan" : "나의 쿠폰",
    "couponSelectPaytypeTip" : "결제 방식 선택 후 할인 내역 확인 가능",
    "couponSelectCouponTip" : "쿠폰 선택 후 할인 가격 확인 가능",
    "couponValidQuanTip" : "(사용 가능 쿠폰 \${num}개)",
    "couponLookCart" : "카트 조회",
    "couponUnfoldCart" : "카트 숨기기",
    "couponCoupon" : "쿠폰",
    "couponNoUse" : "미사용",
    "couponSelect" : "쿠폰 선택",
    "couponSureUse" : "확인",
    "couponReturn" : "뒤로",
    "couponInvalidTime" : "기한 만료일",
    "couponBuyNow" : "바로구매",
    "couponAllType" : "모두",
    "ztmslgType1" : "일일 특혜",
    "ztmslgType2" : "영웅",
    "ztmslgType3" : "전투 장비",
    "ztmslgType4" : "",
    "ztmslgType5" : "칩",
    "ztmslgType6" : "사이보그",
    "ztmslgType7" : "자원",
    "ztmslgType8" : "건설 가속",
    "ztmslgType9" : "희귀 상품",
    "ztmslgType10" : "연맹",
    "ztmslgType11" : "다이아",
    "ztmslgType12" : "부품",
    "ztmslgType13" : "큐브",
    "ztmslgType14" : "",
    "ztmslgType15" : "나노 무기",
    "ztmslgType16" : "최종 보상",
    "ztmslgType17" : "결정핵",
    "ztmslgType9999" : "한정 공급",
    "ztmslgType10000" : "기프트 센터",
    "ztmslgType10001" : "기념일 이벤트",
    "ztmslgTypeother" : "Other",
    "antslgType1" : "일일 할인",
    "antslgType2" : "특종개미",
    "antslgType3" : "장비",
    "antslgType5" : "유전자",
    "antslgType6" : "달팽이",
    "antslgType7" : "자원",
    "antslgType8" : "건설&연구",
    "antslgType9" : "희귀 상품",
    "antslgType10" : "동맹",
    "antslgType11" : "다이아",
    "antslgType12" : "세포",
    "antslgType13" : "토템",
    "antslgType9999" : "한정 할인",
    "antslgTypeother" : "other",
    "typeall" : "모든 상품",
    "vipHead" : "VIP포인트",
    "vipHead213": "프리미엄",
    "vipTitle" : "VIP포인트 이벤트",
    "nowLevel" : "현재 VIP 레벨:",
    "myVipScore" : "나의 포인트:",
    "nextLevelNeed" : "(VIP\${level} 달성까지 \${num}포인트 필요)",
    "ruleTitle" : "이벤트 규칙",
    "ztmslgVipRule1" : "1. 이벤트 기간: 2022년 9월 22일 00:00부터(UTC시간)",
    "ztmslgVipRule2" : "2. 대상 게임: 퍼즐 오브 Z",
    "ztmslgVipRule3" : "이벤트별로 보상은 한번만 받을 수 있습니다.",
    "ztmslgVipRule4" : "3. 로그인 쿠폰 이벤트: 충전 페이지에 첫 로그인 시 15% 할인 쿠폰을 수령할 수 있습니다.",
    "ztmslgVipRule5" : "4. VIP포인트 이벤트: 공식 사이트를 통해 아이템을 구입하시면, 달성하신 포인트 레벨에 따라 레벨 쿠폰 및 이주의 전용 쿠폰을 드립니다.",
    "ztmslgVipRule6" : "5. 각종 통화별 포인트 비율은 <표1>을 참고하세요. 1포인트 미만은 절사됩니다.",
    "ztmslgVipRule7" : "6. 쿠폰을 사용해 주문하실 경우 포인트는 실제 결제 금액 기준으로 적립됩니다.",
    "ztmslgVipRule8" : "7. 포인트 유효기간은 365일이며, VIP레벨은 당기 보유 포인트에 따라 변동됩니다.",
    "ztmslgVipRule9" : "8. 특정 VIP 레벨을 달성하면 즉시 첫 달성 쿠폰과 신규 레벨 주간 쿠폰이 지급됩니다. 그 후 매주 토요일 0시(UTC+0)에 주간 쿠폰이 갱신됩니다.",
    "ztmslgVipRule10" : "9. 주간 쿠폰은 로그인해야 수령할 수 있으며, 수령 기한이 지나면 재발급되지 않습니다. 쿠폰 내용은 비정기적으로 업데이트됩니다.",
    "ztmslgVipRule11" : "10. 쿠폰의 통화는 마지막으로 충전 완료하신 주문서의 통화입니다. 통화를 바꾸고 싶으신 경우 고객센터로 연락해 주세요.",
    "ztmslgVipRule12" : "11. VIP 레벨 및 쿠폰 규칙은 아래와 같습니다",
    "ztmslgVipRule13" : "12. 이번 이벤트의 최종 해석권은 퍼즐 오브 Z 운영팀에 있습니다.",
    "vipLevel" : "VIP 레벨",
    "vipCondition" : "포인트 조건",
    "firstSend" : "최초 달성 시 증정",
    "weeklySend" : "주간 우대 쿠폰",
    "lastAllCoupon" : "이전 레벨의 쿠폰 전부",
    "besides" : "참고",
    "couponRatio" : "통화별 VIP포인트 비율",
    "backToPay" : "뒤로 가기",
    "quanGift" : "쿠폰 혜택",
    "quanGiftTips" : "신규 쿠폰이 도착했습니다. 확인해 주세요~",
    "antslgVipRule1" : "VIP 포인트 이벤트 기능 개편으로 기존 이벤트가 종료됩니다.",
    "antslgVipRule2" : "기존 VIP 포인트 이벤트에서 획득한 혜택 티켓은 유효기간이 초과되지 않도록 사용해 주시기 바랍니다.",
    "antslgVipRule3" : "종료 시간: 2024-09-28 00:00:00(utc)",
    "antslgVipRule4" : "이벤트 종료 후, VIP 센터에서 더 많은 혜택을 경험하실 수 있습니다:",
    "antslgVipRule5" : "퀘스트를 클리어하고 포인트를 획득하여 혜택 티켓, 게임 아이템 등의 보상으로 교환할 수 있습니다! 그 외에도 VIP 전용 혜택, 포인트 뽑기 등 다양한 혜택 이벤트가 준비되어 있습니다.",
    "antslgVipRule6" : "기대해 주세요.",
    "dzgVipRule0" : "1. 이벤트 기간: 2022년 9월 27일 00:00부터(UTC시간)",
    "dzgVipRule1" : "1. 대상 게임: \${gameName}",
    "dzgVipRule2" : "이벤트별로 보상은 한번만 받을 수 있습니다.",
    "dzgVipRule3" : "2. 로그인 쿠폰 이벤트: 충전 페이지에 첫 로그인 시 15% 할인 쿠폰을 수령할 수 있습니다.",
    "dzgVipRule4" : "3. VIP포인트 이벤트: 공식 사이트를 통해 아이템을 구입하시면, 달성하신 포인트 레벨에 따라 레벨 쿠폰 및 이주의 전용 쿠폰을 드립니다.",
    "dzgVipRule5" : "4. 각종 통화별 포인트 비율은 <표1>을 참고하세요. 1포인트 미만은 절사됩니다.",
    "dzgVipRule6" : "5. 쿠폰을 사용해 주문하실 경우 포인트는 실제 결제 금액 기준으로 적립됩니다.",
    "dzgVipRule7" : "6. 포인트 유효기간은 365일이며, VIP레벨은 당기 보유 포인트에 따라 변동됩니다.",
    "dzgVipRule8" : "7. 특정 VIP 레벨을 달성하면 즉시 첫 달성 쿠폰과 신규 레벨 주간 쿠폰이 지급됩니다. 그 후 매주 토요일 0시(UTC+0)에 주간 쿠폰이 갱신됩니다.",
    "dzgVipRule9" : "8. 주간 쿠폰은 로그인해야 수령할 수 있으며, 수령 기한이 지나면 재발급되지 않습니다. 쿠폰 내용은 비정기적으로 업데이트됩니다.",
    "dzgVipRule10" : "9. 쿠폰의 통화는 마지막으로 충전 완료하신 주문서의 통화입니다. 통화를 바꾸고 싶으신 경우 고객센터로 연락해 주세요.",
    "dzgVipRule11" : "10. VIP 레벨 및 쿠폰 규칙은 아래와 같습니다",
    "dzgVipRule12" : "11. 이번 이벤트의 최종 해석권은 \${gameName} 운영팀에 있습니다.",
    "213dzgVipRule1" : "VIP 포인트 이벤트 기능 개편으로 기존 이벤트가 종료됩니다.",
    "213dzgVipRule2" : "기존 VIP 포인트 이벤트에서 획득한 혜택 티켓은 유효기간이 초과되지 않도록 사용해 주시기 바랍니다.",
    "213dzgVipRule3" : "종료 시간: 2024-08-19 08:00:00(utc)",
    "213dzgVipRule4" : "이벤트 종료 후, VIP 센터에서 더 많은 혜택을 경험하실 수 있습니다:",
    "213dzgVipRule5" : "퀘스트를 클리어하고 포인트를 획득하여 혜택 티켓, 게임 아이템 등의 보상으로 교환할 수 있습니다! 그 외에도 VIP 전용 혜택, 포인트 뽑기 등 다양한 혜택 이벤트가 준비되어 있습니다.",
    "213dzgVipRule6" : "기대해 주세요.",
    "getReward" : "전용 프로필",
    "unbindEntry" : "계정 연동/해제",
    "unbindApply" : "연동 해제 신청",
    "unbindConfirmTitle" : "연동을 해제하겠습니까?",
    "unbindConfirmTip" : "연동 해제 시 해당 계정의 게임 진행도를 잃어버릴 수 있습니다. 정말 해제할까요?",
    "unbindConfirm" : "네, 연동을 해제합니다",
    "unbindExit" : "아니오",
    "unbindSucc" : "해제 성공",
    "unbindFail" : "해제 실패, 고객센터에 문의해 주세요",
    "unbindServiceTitle" : "고객센터를 통해 신청해 주세요",
    "unbindContact" : "고객센터 문의",
    "unbindServiceTip" : "자동 연동 해제가 불가능합니다. 고객센터로 해제 신청하세요",
    "antslgType15" : "계승의 힘",
    "shareEventTitle" : "친구 초대하고</br>선물 받자",
    "shareRule" : "규칙",
    "awardBag" : "내 보상",
    "initiatorText" : "친구를 초청할래요",
    "inviteeText" : "친구의 초청을 받았어요",
    "createCode" : "초청 코드 생성하기",
    "createCodeTip" : "탭해서 나만의 초청 코드 생성하기",
    "createLinkTip" : "탭해서 나만의 초청 링크 생성하기",
    "copyText" : "복사",
    "shareCode" : "초청 코드 공유하기",
    "twShare" : "",
    "fbShare" : "",
    "dcShare" : "",
    "seeAward" : "보상 확인",
    "seeAwardTip" : "<span class=\"see-light\">VIP 포인트</span>><span class=\"see-light\">나의 쿠폰</span> 메뉴에서 확인 후 사용하세요",
    "inviteReward" : "초청 보상",
    "inviteRewardTip" : "초청자는 친구가 각각의 충전 조건을 달성했을 때 해당 보상을 친구당 한번만 받을 수 있습니다.",
    "overweightReward" : "추가 보상",
    "resetTip" : "매달 말일 00:00에 초기화（UTC+0）",
    "rewardText1" : "초청 받은 친구가 총 9.99USD 충전 시",
    "rewardText2" : "초청 받은 친구가 총 49.99USD 충전 시",
    "rewardText3" : "초청 받은 친구가 총 99.99USD 충전 시",
    "rewardText4" : "5명 초청 시마다 12% 할인쿠폰 획득!",
    "rewardText5" : "초청 받은 친구가 총 1000USD 충전 시 15% 할인쿠폰 획득!",
    "invitationList" : "초청 내역",
    "refresh" : "새로고침",
    "invitedTotal" : "초청한 친구: \${total}",
    "storedTotal" : "충전금액: \${total} USD",
    "people" : "",
    "invitedPeople" : "초청한 친구",
    "invitedTime" : "초대 시간",
    "got" : "달성 완료",
    "get" : "미달성",
    "overlay" : "중복 적용 가능",
    "couponText" : "쿠폰",
    "personalReward" : "충전 보상",
    "personalRewardText1" : "총 9.99USD 충전",
    "personalRewardText2" : "총 49.99USD 충전",
    "personalRewardText3" : "총 99.99USD 충전",
    "inputCode" : "초청 코드 입력",
    "bindCode" : "확인",
    "bindSucc" : "확인 완료",
    "codeTip1" : "잘못된 초청 코드입니다. 다시 입력하세요",
    "codeTip2" : "초청 코드 연동 완료",
    "copySucc" : "복사 성공",
    "awardName" : "보상",
    "getTime" : "획득일",
    "getCondition" : "획득 조건",
    "couponText1" : "6% 할인쿠폰",
    "couponText2" : "8% 할인쿠폰",
    "couponText3" : "10% 할인쿠폰",
    "couponText4" : "12% 할인크폰",
    "couponText5" : "15% 할인쿠폰",
    "ruleText1" : "1. 이벤트 기간: 2022년 11월 25일 00:00부터(UTC 기준)",
    "ruleText2" : "2. 대상 게임: 퍼즐 오브 Z",
    "ruleText3" : "3. \'공식 페이지 충전 공유\' 이벤트: 공식 충전 페이지를 친구에게 공유 및 초대하여, 충전액이 일정 금액 이상이 되면 보상을 획득합니다",
    "ruleText4" : "4. \'서드파티 충전 공유 월간 보상\' 이벤트: 매달 공유 목표를 달성하면 이에 따른 보상을 획득하며, 보상은 매월 갱신됩니다",
    "ruleText5" : "5. 월간 보상은 신규 유저 초대 후 서드파티 채널에서 충전해야 함",
    "ruleText6" : "6. 월간 보상은 매월 1일에 갱신되며 지난 달 진행도는 초기화됩니다",
    "ruleText7" : "7. 보상으로 지급되는 쿠폰은 서드파티 결제 화면에 로그인해 수령하며, 수령 기간 만료 시 재발급되지 않습니다",
    "ruleText8" : "8. 쿠폰의 통화는 마지막으로 충전을 완료하신 통화로 발급됩니다. 다른 통화로 교체하시려면 고객센터로 문의해 주세요",
    "ruleText9" : "9. 유저 두 사람이 서로의 초대 코드를 연동할 수 없습니다",
    "ruleTableTitle1" : "보상 규칙：",
    "ruleTableTitle2" : "VIP 레벨 및 할인권 증정 규칙∶",
    "ruleTableHead1" : "충전 기준",
    "ruleTableHead2" : "보상 기준",
    "ruleTableHead3" : "보상",
    "ruleTableContent1" : "신규 유저 5명 초대",
    "ruleTableContent2" : "초대한 유저가 1000USD 이상 충전",
    "errorTip" : "조작 실패",
    "eventShareText1" : "퍼즐 오브 Z: 종말 스토어 한정 특혜 이벤트 진행 중",
    "eventShareText2" : "쏟아지는 혜택을 잡아라",
    "cartDoubleTip" : "쇼핑카트는 2배권 사용을 지원하지 않습니다",
    "codeTip3" : "미로그인",
    "codeTip4" : "파라메타 부족",
    "codeTip5" : "자신의 초대 코드는 연동할 수 없습니다",
    "codeTip6" : "초대 코드 생성 완료",
    "payWelfare" : "충전 혜택",
    "wallet" : "지갑",
    "myDiscount" : "내 쿠폰",
    "knowMore" : "더 보기",
    "backPay" : "뒤로",
    "curBalance" : "현재 잔액",
    "pay" : "충전",
    "changeCoin" : "교환 화폐",
    "watchDesc" : "상세 보기",
    "getMore" : "더 많은 혜택",
    "getDiscount" : "쿠폰 획득",
    "notOpenDiscountQuan" : "쿠폰 이벤트가 없습니다. 다음 이벤트를 기대하세요!",
    "abountZbit" : "\${Z-BIT}란?",
    "remain" : "잔액:",
    "payRemain" : "결제 후 예상 잔액",
    "payRemainExpiry" : "결제 후 예상 잔액은 ${money}입니다(2026년 1월 1일 만료 예정이니 가능한 한 빨리 사용하세요).",
    "balanceNotEnoughExpiry" : "잔액 부족(26년 1월 1일 만료, 충전 불가)",
    "balanceNotEnoggh" : "잔액이 부족합니다. 충전해 주세요",
    "goToPay" : "충전하기",
    "chooseOtherPay" : "결제방식 바꾸기",
    "payIntro" : "충전 설명",
    "logRole" : "캐릭터",
    "chooseProduct" : "상품 선택",
    "meAgree" : "위 내용을 읽었으며 내용에 동의합니다",
    "coinAgreeText" : "",
    "aboutCoin" : "",
    "coinsPayTokenLogin" : "\${Z-BIT} 사용 전에는 OTP 인증코드 인증이 필요합니다",
    "dl3dvnVipRule1" : "1. 대상 게임: \${gameName}",
    "dl3dvnVipRule2" : "이벤트별로 보상은 한번만 받을 수 있습니다.",
    "dl3dvnVipRule3" : "2. 로그인 쿠폰 이벤트: 충전 페이지에 첫 로그인 시 15% 할인 쿠폰을 수령할 수 있습니다.",
    "dl3dvnVipRule4" : "3. VIP포인트 이벤트: 공식 사이트를 통해 아이템을 구입하시면, 달성하신 포인트 레벨에 따라 레벨 쿠폰 및 이주의 전용 쿠폰을 드립니다.",
    "dl3dvnVipRule5" : "4. 각종 통화별 포인트 비율은 <표1>을 참고하세요. 1포인트 미만은 절사됩니다.",
    "dl3dvnVipRule6" : "5. 쿠폰을 사용해 주문하실 경우 포인트는 실제 결제 금액 기준으로 적립됩니다.",
    "dl3dvnVipRule7" : "6. 포인트 유효기간은 365일이며, VIP레벨은 당기 보유 포인트에 따라 변동됩니다.",
    "dl3dvnVipRule8" : "7. 특정 VIP 레벨을 달성하면 즉시 첫 달성 쿠폰과 신규 레벨 주간 쿠폰이 지급됩니다. 그 후 매주 토요일 0시(UTC+0)에 주간 쿠폰이 갱신됩니다.",
    "dl3dvnVipRule9" : "8. 주간 쿠폰은 로그인해야 수령할 수 있으며, 수령 기한이 지나면 재발급되지 않습니다. 쿠폰 내용은 비정기적으로 업데이트됩니다.",
    "dl3dvnVipRule10" : "9. 쿠폰의 통화는 마지막으로 충전 완료하신 주문서의 통화입니다. 통화를 바꾸고 싶으신 경우 고객센터로 연락해 주세요.",
    "dl3dvnVipRule11" : "10. VIP 레벨 및 쿠폰 규칙은 아래와 같습니다",
    "dl3dvnVipRule12" : "",
    "dl3dvnVipRule13" : "12. 이번 이벤트의 최종 해석권은 \${gameName} 운영팀에 있습니다.",
    "codeTip7" : "해당 유저가 귀하의 초대 코드를 연동 중입니다. 이 유저의 초대 코드는 연동할 수 없습니다.",
    "ruleText10" : "10. 이 이벤트의 해석권은 <퍼즐 오브 Z> 운영팀에 있습니다.",
    "payCoins" : "충전 VIP 포인트",
    "shareGift" : "공유하고 선물받기",
    "attentionCoinUse" : "안내: 통화별 잔액은 통용되지 않습니다",
    "noPayWay" : "선택한 지역에 사용할 수 있는 결제 수단이 없습니다. 지역을 변경하고 다시 시도하세요.",
    "dl3dtwVipRule1" : "1. 대상 게임: \${gameName}",
    "dl3dtwVipRule2" : "이벤트별로 보상은 한번만 받을 수 있습니다.",
    "dl3dtwVipRule3" : "2. VIP포인트 이벤트: 공식 사이트를 통해 아이템을 구입하시면, 달성하신 포인트 레벨에 따라 레벨 쿠폰 및 이주의 전용 쿠폰을 드립니다.",
    "dl3dtwVipRule4" : "3. 각종 통화별 포인트 비율은 <표1>을 참고하세요. 1포인트 미만은 절사됩니다.",
    "dl3dtwVipRule5" : "4. 쿠폰을 사용해 주문하실 경우 포인트는 실제 결제 금액 기준으로 적립됩니다.",
    "dl3dtwVipRule6" : "5. 포인트 유효기간은 365일이며, VIP레벨은 당기 보유 포인트에 따라 변동됩니다.",
    "dl3dtwVipRule7" : "6. 특정 VIP 레벨을 달성하면 즉시 첫 달성 쿠폰과 신규 레벨 주간 쿠폰이 지급됩니다. 그 후 매주 토요일 0시(UTC+0)에 주간 쿠폰이 갱신됩니다.",
    "dl3dtwVipRule8" : "7. 주간 쿠폰은 로그인해야 수령할 수 있으며, 수령 기한이 지나면 재발급되지 않습니다. 쿠폰 내용은 비정기적으로 업데이트됩니다.",
    "dl3dtwVipRule9" : "8. 쿠폰의 통화는 마지막으로 충전 완료하신 주문서의 통화입니다. 통화를 바꾸고 싶으신 경우 고객센터로 연락해 주세요.",
    "dl3dtwVipRule10" : "9. VIP 레벨 및 쿠폰 규칙은 아래와 같습니다",
    "dl3dtwVipRule11" : "10. 이번 이벤트의 최종 해석권은 \${gameName} 운영팀에 있습니다.",
    "eventInviteSucc" : "초대 성공",
    "eventGainCondition" : "획득 조건",
    "eventSuccInvite" : "친구 초대 성공",
    "eventInviteGainOne" : "초대 받은 친구가 \n총 49.99USD 충전 시",
    "eventInviteGainTwo" : "초대 받은 친구가\n총 99.99USD 충전 시",
    "eventFriendCode" : "친구의 초대 코드:",
    "eventCheckBind" : "연동하시겠습니까?",
    "eventConfirm" : "확인",
    "eventCancel" : "취소",
    "eventBindSucc" : "연동되었습니다!",
    "eventGainCoupon" : "축하합니다. 쿠폰을 획득했습니다!",
    "eventLookCoupon" : "쿠폰 보기",
    "eventSuccBind" : "연동되었습니다",
    "recaptchaTip" : "인증 코드를 입력하세요",
    "completeRecaptcha" : "본인 인증을 완료해 주세요",
    "recaptchaExpired" : "인증이 만료되었습니다. 다시 인증해 주세요",
    "inputAccountName" : "되찾으려는 계정을 입력하세요",
    "pwaPayTip" : "결제를 더욱 빠르고 원활하게",
    "pwsInstall" : "바탕화면 바로가기 아이콘 생성",
    "ztmslgType999" : "쿠폰",
    "coinUseTips" : "쿠폰은 게임 우편으로 발송됩니다. 게임 내 쿠폰 상점에서 원하는 상점을 구매할 수 있으며, 쿠폰 소모 시 누적 충전 보상을 획득할 수 있습니다.",
    "notice" : "공지",
    "popupConfirm" : "확인",
    "hideWithinWeek" : "7일 내 다시 알리지 않기",
    "ztmslgProductOffTips" : "최근 결제 페이지 업데이트와 관련하여 유저 여러분께서 많은 피드백과 건의를 주셨습니다. 당사는 유저 여러분의 의견을 수렴해, 기존 3월 13일로 예정되었던 변경 계획을 취소하기로 결정하였습니다. 당사는 앞으로도 유저 여러분께 더 나은 구매 경험을 드리기 위해 끊임없이 노력하겠습니다. 양해와 성원에 감사드립니다! 문의사항이 있으신 경우 고객센터로 문의 주시기 바랍니다. 감사합니다.",
    "couponTopLimit" : "할인한도",
    "swsjpVipRule1" : "1. 이벤트 기간: 2023년 3월 24일 00:00부터(UTC시간)",
    "swsjpVipRule2" : "2. 대상 게임: \${gameName}",
    "swsjpVipRule3" : "이벤트별로 보상은 한번만 받을 수 있습니다.",
    "swsjpVipRule4" : "3. 로그인 쿠폰 이벤트: 충전 페이지에 첫 로그인 시 15% 할인 쿠폰을 수령할 수 있습니다.",
    "swsjpVipRule5" : "4. VIP포인트 이벤트: 공식 사이트를 통해 아이템을 구입하시면, 달성하신 포인트 레벨에 따라 레벨 쿠폰 및 이주의 전용 쿠폰을 드립니다.",
    "swsjpVipRule6" : "5. 각종 통화별 포인트 비율은 <표1>을 참고하세요. 1포인트 미만은 절사됩니다.",
    "swsjpVipRule7" : "6. 쿠폰을 사용해 주문하실 경우 포인트는 실제 결제 금액 기준으로 적립됩니다.",
    "swsjpVipRule8" : "7. 기존 충전 내역은 일정 비율에 따라 초기 포인트로 전환되었습니다.",
    "swsjpVipRule9" : "8. 포인트 유효기간은 365일이며, VIP레벨은 당기 보유 포인트에 따라 변동됩니다.",
    "swsjpVipRule10" : "9. 특정 VIP 레벨을 달성하면 즉시 첫 달성 쿠폰과 신규 레벨 주간 쿠폰이 지급됩니다. 그 후 매주 토요일 0시(UTC+0)에 주간 쿠폰이 갱신됩니다.",
    "swsjpVipRule11" : "10. 주간 쿠폰은 로그인해야 수령할 수 있으며, 수령 기한이 지나면 재발급되지 않습니다. 쿠폰 내용은 비정기적으로 업데이트됩니다.",
    "swsjpVipRule12" : "11. 쿠폰의 통화는 마지막으로 충전 완료하신 주문서의 통화입니다. 통화를 바꾸고 싶으신 경우 고객센터로 연락해 주세요.",
    "swsjpVipRule13" : "12. 이번 이벤트의 최종 해석권은 \${gameName} 운영팀에 있습니다.",
    "beautyVipRule1" : "",
    "beautyVipRule2" : "",
    "beautyVipRule3" : "",
    "beautyVipRule4" : "",
    "beautyVipRule5" : "",
    "beautyVipRule6" : "",
    "beautyVipRule7" : "",
    "beautyVipRule8" : "",
    "beautyVipRule9" : "",
    "beautyVipRule10" : "",
    "beautyVipRule11" : "",
    "antslgType999" : "할인 쿠폰",
    "passAskMods" : "모드에게 질문하기",
    "passAskModsTip" : "게임에 관한 모든 궁금한 점은 모드에게 질문할 수 있습니다",
    "passService" : "고객센터",
    "passServiceTip" : "계정과 충전 관련 문제는 고객센터에 연락하세요",
    "passIKonw" : "확인",
    "passGoOn" : "계속 질문하기",
    "voucherTitle" : "공식 결제센터",
    "voucherAddHome" : "바탕화면에 추가",
    "voucherAddHomeTipOne" : "더 빠른 결제, 더 편한 서비스",
    "voucherAddHomeTipTwo" : "[공유] 버튼을 누르고",
    "voucherAddHomeTipThree" : "[바탕화면에 추가]를 선택합니다",
    "voucherLoginLook" : "로그인해서 혜택을 확인하세요",
    "voucherSwitchRole" : "캐릭터 변경",
    "voucherCoupon" : "할인권",
    "voucherVip" : "VIP포인트",
    "voucherMoreCoupon" : "더 보기",
    "voucherAccountId" : "계정ID",
    "voucherOtp" : "OTP",
    "voucherOtherWayPay" : "다른 결제 방식 선택",
    "voucherOtherLoginWay" : "다른 로그인 방식 선택",
    "voucherCouponActivity" : "할인 이벤트",
    "voucherActivityNotBegin" : "이벤트 준비 중. 많이 기대해주세요",
    "voucherGoCommunity" : "커뮤니티로 이동해 더 많은 혜택을 확인하세요",
    "voucherValidTime" : "유효기간",
    "voucherLimitRegion" : "\${currency}결제만 사용 가능",
    "voucherLiuyi" : "할인권이 없습니다. 공식 이벤트 정보에 유의하세요",
    "voucherPay" : "할인권 구매",
    "voucherAbout" : "할인권 설명",
    "voucherChooseWay" : "결제 방식 선택",
    "voucherMoreWay" : "더 많은 결제 방식 조회",
    "voucherChooseCoupon" : "선택한 할인권",
    "voucherHasChoose" : "선택 완료",
    "voucherMoneyInsufficient" : "잔액이 부족합니다",
    "voucherContact" : "잔액이 부족합니다. 고객센터에 연락하세요",
    "voucherCouponTotal" : "사용 가능한 할인권 수량",
    "voucherCouponTipGuide" : "결제 수단을 선택한 후에 결제 시 할인권을 선택할 수 있습니다",
    "voucherPaytypeNotSupport" : "할인권 사용을 지원하지 않는 결제 수단입니다",
    "voucherTipSideOne" : "쿠폰은 게임 할인권 교환을 제외한 모든 패키지 및 서비스 교환에 사용할 수 있습니다",
    "voucherTipSideTwo" : "최대 15% OFF",
    "voucherYue" : "잔액",
    "jpUidLoginName" : "",
    "jpUidToken" : "",
    "jpUidInputToken" : "",
    "pnsBook" : "종말 생존수첩",
    "vipHeadText" : "축하합니다! VIP 전용 프레임을 획득하셨습니다.",
    "vipHeadGetText" : "지금 수령",
    "vipHeadGotText" : "수령 완료",
    "vipHeadGetTitle" : "확인",
    "vipHeadGetTip" : "계정당 1회만 수령할 수 있습니다. 정말 현재 캐릭터에 수령하시겠습니까?",
    "vipHeadAwardText" : "에이스 지휘관(영구)",
    "vipHeadGetErrTip1" : "수령 실패. 잠시 후 다시 시도하시거나 고객센터로 연락해 주세요.",
    "cartGuideTipNew" : "추가　구매　시　할인권　사용　가능",
    "newVipTitle" : "공식 충전 센터 VIP",
    "newVipLogin" : "로그인",
    "newVipNowPoint" : "현재 포인트:",
    "newVipNextLevel" : "다음 레벨까지 \${point} 포인트 필요",
    "newVipUpgrade" : "레벨 업",
    "newVipLevel" : "VIP레벨 혜택",
    "newVipTip" : "할인권은 토요일 UTC 0시에 갱신되며 공식 충전 페이지에 접속하면 자동 지급됩니다.",
    "newVipWeekly" : "주간 선물",
    "newVipReachPoint" : "달성 조건:",
    "newVipRuleInfo" : "규칙 설명:",
    "pleaseLang" : "언어 선택",
    "reference" : "주문 번호",
    "saveToNext" : "다시 결제 시 사용하도록 저장하기",
    "cardNum" : "카드 번호",
    "expireTime" : "유효 기간",
    "CVV" : "보안 코드",
    "pleaseCard" : "신용카드 종류를 선택하세요",
    "howToPay" : "결제 방식을 선택하세요",
    "checkCard" : "카드 번호를 확인하세요",
    "checkExpiryDate" : "유효 기간을 확인하세요",
    "checkCVV" : "보안 코드를 확인하세요",
    "addCard" : "신규",
    "delete" : "삭제",
    "deleteCardTips" : "저장한 신용카드 정보를 삭제합니다",
    "confirmDelete" : "삭제",
    "cancelDelete" : "취소",
    "checkAllCardMsg" : "카드 번호, 유효 기간과 보안 카드를 확인해주세요",
    "leaveCreditPageTips" : "나가면 결제가 실패됩니다. 나가시겠습니까?",
    "sureToLeave" : "나가기",
    "continueToPay" : "취소",
    "pushTest" : "푸시 진단",
    "getNoticication" : "게임 푸시 메시지를 받을 수 없습니까?",
    "waitCheckResult" : "원인을 파악하기 위해 진단 결과를 기다려주세요.",
    "hadAbnormal" : "에러 사항을 발견했습니다.",
    "clickIntro" : "터치해 가이드를 확인하세요.",
    "networkCheck" : "네트워크 환경 진단",
    "noticeAuthorityCheck" : "푸시 권헌 진단",
    "noticeBtnCheck" : "알림창 오픈 여부 진단",
    "gmsCheck" : "GMS 서비스 진단",
    "batteryCheck" : "배터리 최적화 리스트 진단",
    "pushServiceCheck" : "푸시 서비스 진단",
    "reCheck" : "다시 진단하기",
    "noNoticeAuthorityTip" : "게임 푸시 권한을 설정하지 않았습니다. 시스템 설정-알림에서 게임을 선택하고 알림 권한을 허용하세요.",
    "noNoticeBtnTip" : "게임의 알림창을 오픈하지 않았습니다. 시스템 설정에서 오픈하세요.",
    "noBatteryTip" : "게임이 기기의 배터리 최적화 리스트에 있어서 푸시를 받지 못할 수 있습니다. 시스템 설정-배터리-배터리 최적화에서 게임을 화이트 리스트에 추가하세요.",
    "noPushServiceTip" : "푸시 서버 연결 실패. [연결]을 터치해 서버 연결을 시도하세요.",
    "noNetworkTip" : "네트워크가 불안정합니다. 안정된 네트워크 환경에서 이용해주세요.",
    "noGmsTip" : "기기가 GMS(구글 모바일 서비스)를 지원하지 않습니다. GMS를 지원하는 기기로 교체하세요.",
    "pushConnectFail" : "푸시 서버 연결 실패",
    "pushConnectSucc" : "푸시 서버 연결 성공",
    "noGetPushTitle" : "여전히 게임 알림을 받지 못할 경우 아래 절차에 따라 체크 부탁드립니다.",
    "noGetPushContOne" : "1. 기기에서 게임을 종료하고 재접속합니다.",
    "noGetPushContTwo" : "2. [푸시 진단]을 터치해 테스트용 알림 메시지를 수신받을 수 있는지 확인합니다.",
    "noGetPushContThree" : "3. 테스트용 알림 메시지를 받을 수 있지만 게임 내 푸시 알림을 못받는 경우, 게임-설정-알림에서 모든 알림이 켜져 있는지 확인합니다.",
    "noGetPushContFour" : "4. 여전히 푸시 알림을 못받는 경우 고객센터에 연락하세요.",
    "getPushSucc" : "테스트용 푸시 알림을 수신받았습니다! 수신 기능을 정상적으로 사용하실 수 있습니다.",
    "allCheckSucc" : "모든 진단 항목에 문제가 없습니다.",
    "pushCheck" : "푸시 진단",
    "useDirectPay" : "간편 결제",
    "paypalFraudnetInfo" : "결제 정보는 페이팔 리스크 엔진의 보호를 받습니다.",
    "goToSetting" : "설정",
    "retry" : "다시 시도",
    "connect" : "연결",
    "canRebind" : "해제 후 다시 연동할 수 있습니다",
    "agreePlatform" : "\${service} 및 \${privite}에 동의합니다",
    "sendGameNews" : "게임 최신 정보 구독하기",
    "canNotBindEmail" : "해제 후 해당 이메일로 로그인할 수 없습니다",
    "canNotBindPhone" : "해제 후 해당 휴대폰 번호로 로그인할 수 없습니다",
    "canChangeByEmail" : "이메일로 여러 기기에서 로그인할 수 있습니다",
    "canChangeByPhone" : "휴대폰 번호로 여러 기기에서 로그인할 수 있습니다",
    "loginSucc" : "로그인 성공",
    "phoneHadBind" : "연동된 휴대폰 번호입니다. 직접 로그인하시겠습니까?",
    "emailHadBind" : "연동된 이메일 주소입니다. 직접 로그인하시겠습니까?",
    "phoneNotBind" : "연동되지 않은 휴대폰 번호입니다. 새 계정을 생성하시겠습니까?",
    "emailNotBind" : "연동되지 않은 이메일 주소입니다. 새 계정을 생성하시겠습니까?",
    "emailAccount" : "이메일",
    "phoneAccount" : "휴대폰",
    "phoneInputError" : "잘못된 휴대폰 번호입니다",
    "registerNewAccount" : "새 계정 생성",
    "secureTip" : "대리 충전과 계정 안전 관련 안내",
    "toTop" : "상단 핀 고정",
    "createNewWork" : "새 질문",
    "serviceEvaluate" : "평가",
    "emailRemind" : "이메일 안내",
    "isAgreeService" : "서비스에 만족하십니까?",
    "thankEvaluateTop" : "소중한 의견 감사합니다.",
    "inputValidEmail" : "유효한 이메일 주소를 입력하세요.",
    "replyWillRemind" : "회신을 받으면 이메일로 안내 메시지가 발송됩니다. 이메일 안내 기능을 다시 터치해 해당 서비스를 취소할 수 있습니다.",
    "isCancelEmailRemind" : "취소하면 이메일 안내를 받을 수 없습니다. 취소하시겠습니까?",
    "reconfirmEmail" : "이메일 주소를 확인하세요",
    "confirmCanSubmit" : "확인 후 제출할 수 있습니다",
    "serviceWillReply" : "회신을 받으면 이메일로 안내 메시지가 발송됩니다.",
    "cancelEmailRemind" : "[이메일 안내]를 취소하시겠습니까?",
    "yes" : "예",
    "no" : "아니오",
    "inputWorkSearch" : "검색 키워드를 입력하세요",
    "loading" : "로딩 중",
    "loadingError" : "로딩 실패. 터치해 다시 로딩하세요...",
    "noMore" : "더 이상의 내용은 없습니다",
    "cancelToTop" : "상단 핀 해제",
    "evaluateOne" : "매우 불만족",
    "evaluateTwo" : "불만족",
    "evaluateThree" : "일반",
    "evaluateFour" : "만족",
    "evaluateFive" : "매우 만족",
    "confirmDelWorkTop" : "해당 질문을 삭제하시겠습니까?",
    "reRemindEmail" : "이메일 안내를 원하시는 경우 [이메일 안내]를 다시 터치하세요.",
    "confirmWillReply" : "확인 후 고객센터의 회신을 받으면 이메일로 안내 메시지가 발송됩니다.",
    "thankEvaluateBottom" : "",
    "confirmDelWorkBottom" : "삭제 후 회신이 불가능합니다.",
    "morePurchaseWay" : "결제 수단 더 보기",
    "purchaseNeed" : "상품 구매 가격:",
    "videoUploadSucc" : "비디오 업로드 성공",
    "videoUploadFail" : "비디오 업로드 실패",
    "videoUploadLimit" : "mp4 형식의 비디오만 업로드 가능하며, 비디오 크기는 400Mb를 초과할 수 없으며, 비디오 길이는 2분을 초과할 수 없습니다.",
    "imageUploadSucc" : "이미지 업로드 성공",
    "imageUploadFail" : "이미지 업로드 실패",
    "uploading" : "업로드 중",
    "smartOrderCreate" : "문서 바로가기",
    "smartOrderSearch" : "검색",
    "smartOrderComing" : "많은 기대 바랍니다",
    "smartOrderContactService" : "고객센터",
    "smartOrderDetector" : "진단 도우미",
    "smartOrderDetect" : "진단",
    "smartOrderDetecting" : "진단 중",
    "smartOrderDetectTip" : "게임에서 발생한 오류를 발견했습니다. 진단을 누르면 문제가 무엇인지 파악할 수 있습니다.",
    "smartOrderDetectTip2" : "문제의 원인을 파악했습니다. 문제를 제출하시면 문제를 해결해 드리겠습니다.",
    "smartOrderSubmit" : "제출",
    "smartOrderIKnow" : "알겠습니다",
    "smartOrderConfirm" : "확인",
    "smartOrderLook" : "살펴보기",
    "smartOrderIsHelp" : "이 글이 도움되셨나요?",
    "smartOrderInputQuestion" : "어떤 문제가 있으신가요?",
    "smartOrderPleaseInpt" : "입력해 주세요",
    "smartOrderPleaseChoose" : "선택해 주세요",
    "smartOrderStoreTime" : "충전 시간",
    "smartOrderInputOrder" : "주문서 번호를 입력하세요",
    "smartOrderInputPrice" : "주문서 금액을 입력하세요",
    "smartOrderNeedHelp" : "안녕하세요, 어떤 도움이 필요하신가요?",
    "smartOrderLookHelpTip" : "일반적인 문제에 대한 해결 방법을 확인할 수 있습니다.",
    "smartOrderNoResult" : "현재 검색 결과가 없습니다. 기타 내용을 검색 해주세요.",
    "smartOrderUpdateTime" : "최신 수정 시간",
    "smartOrderSelectStoreTime" : "충전 시간을 선택해 주세요",
    "smartOrderAtlestChoose" : "최소 한 개의 항목을 기입해 주세요",
    "workHomeTitle": "고객센터",
    "workHomeCurServer": "현재 서버",
    "workHomeSearchPlaceholder": "키워드를 입력하여 빠르게 답변 찾기",
    "workHomeSelfService": "셀프 서비스",
    "selfServiceRegisterDate": "가입 연월",
    "selfServiceSocialType": "소셜 계정",
    "selfServiceDeviceType": "기기 유형",
    "selfServiceDeviceId": "기기 ID",
    "selfServicePhoneModel": "휴대폰 모델",
    "selfServicePayOrder": "결제 주문번호",
    "selfServicePayChannel": "결제 채널",
    "selfServiceWorkId": "문의 번호",
    "workHomeAiService": "스마트 고객 서비스",
    "workHomeArtificialService": "상담원 연결",
    "workHomeServiceEntrance": "최선을 다해 서비스하겠습니다",
    "workHomePortraitFooterTip": "- 추가 문의는 키워드를 입력해 검색해 주세요 -",
    "pwaInstallAward" : "바로가기를 만들고",
    "getMasonry" : "다이아를 받자",
    "addToDrawerVisit" : "바탕화면 바로가기를 만드세요",
    "immeAddToGet" : "지금 만들면 한정 보상을 수령할 수 있습니다",
    "add" : "만들기",
    "talkNextTime" : "나중에",
    "chooseRoleGetGift" : "보상 수령",
    "getGiftSuccess" : "수령 완료. 게임에서 보상을 확인하세요.",
    "dmaTitle" : "마케팅 활용 동의",
    "dmaTitleSub" : "(선택)",
    "newAdd" : "신규",
    "smartDelete" : "삭제",
    "wordLengthTip" : "(0-600자 제한)",
    "areaLimitSwitchRegion" : "지역 변경",
    "areaLimitCurrentRegionCurrency" : "현재 지역과 결제 화폐",
    "areaLimitRegion" : "지역:",
    "areaLimitCurrency" : "결제 화폐:",
    "areaLimitNote" : "유의사항:",
    "areaLimitSwitchLimitation" : "단일 계정은 1년에 한 번 지역을 변경할 수 있습니다.",
    "areaLimitPostSwitchCoupon" : "변경 완료 시 새로 얻은 쿠폰은 새로운 지역의 화폐로 발급됩니다.",
    "areaLimitRemainingSwitches" : "현재 남은 횟수: \${times}",
    "areaLimitNoRemainingSwitches" : "남은 횟수 없음",
    "areaLimitUnableToSwitchThisYear" : "올해는 변경할 수 없습니다",
    "areaLimitCannotSwitch" : "변경할 수 없습니다",
    "areaLimitNavigateToSwitch" : "변경",
    "areaLimitConfirmSwitch" : "확인",
    "areaLimitPreSwitchRegionCurrency" : "변경 전 지역과 결제 화폐",
    "areaLimitPostSwitchRegionCurrency" : "변경 후 지역과 결제 화폐",
    "areaLimitPostSwitchRestriction" : "전환 시 올해는 결제 지역을 변경할 수 없습니다.",
    "areaLimitUnusedZBitWarning" : "사용하지 않은 Z-Bit가 있습니다. 지역 변경 시 해당 Z-Bit를 사용할 수 없습니다. 계속하시겠습니까?",
    "areaLimitConfirm" : "확인",
    "areaLimitCancel" : "취소",
    "areaLimitInconsistencyWarning" : "방문 지역과 결제 지역이 일치하지 않습니다",
    "areaLimitPromptToSwitch" : "지역을 변경하시겠습니까?",
    "areaLimitEnterZipCode" : "*Please enter your zipcode",
    "areaLimitEnterInvalid" : "Zipcode is invalid, please re-enter",
    "areaLimitTaxRateTips" : "Depending on your location, the tax rate may vary, the payment amount shall prevail",
    "areaLimitInfoCollect" : "For information collection protection, please refer to the Privacy Policy",
    "getAward" : "보상 수령",
    "selectProductTitle" : "상품 선택",
    "hotSuggest" : "인기 추천",
    "inputKeywordSearch" : "키워드 검색 입력",
    "lookProductContent" : "상품 내용 보기",
    "popupClose" : "닫기",
    "productSwitch" : "상품 교환",
    "confirmBuy" : "구매 확인",
    "thinkLater" : "다시 고민하기",
    "areaLimitConfirmRegion" : "지역 확인",
    "areaLimitContinuePay" : "계속 결제",
    "areaLimitSwitchLimitationTwice" : "단일 계정은 1년에 두 번 지역을 변경할 수 있습니다.",
    "dtmslgVipRule1" : "1. 대상 게임: \${gameName}",
    "dtmslgVipRule2" : "이벤트별로 보상은 한번만 받을 수 있습니다.",
    "dtmslgVipRule3" : "2. VIP포인트 이벤트: 공식 사이트를 통해 아이템을 구입하시면, 달성하신 포인트 레벨에 따라 레벨 쿠폰 및 이주의 전용 쿠폰을 드립니다.",
    "dtmslgVipRule4" : "3. 각종 통화별 포인트 비율은 <표1>을 참고하세요. 1포인트 미만은 절사됩니다.",
    "dtmslgVipRule5" : "4. 쿠폰을 사용해 주문하실 경우 포인트는 실제 결제 금액 기준으로 적립됩니다.",
    "dtmslgVipRule6" : "5. 포인트 유효기간은 365일이며, VIP레벨은 당기 보유 포인트에 따라 변동됩니다.",
    "dtmslgVipRule7" : "6. 특정 VIP 레벨을 달성하면 즉시 첫 달성 쿠폰과 신규 레벨 주간 쿠폰이 지급됩니다. 그 후 매주 토요일 0시(UTC+0)에 주간 쿠폰이 갱신됩니다.",
    "dtmslgVipRule8" : "7. 주간 쿠폰은 로그인해야 수령할 수 있으며, 수령 기한이 지나면 재발급되지 않습니다. 쿠폰 내용은 비정기적으로 업데이트됩니다.",
    "dtmslgVipRule9" : "8. 쿠폰의 통화는 마지막으로 충전 완료하신 주문서의 통화입니다. 통화를 바꾸고 싶으신 경우 고객센터로 연락해 주세요.",
    "dtmslgVipRule10" : "9. VIP 레벨 및 쿠폰 규칙은 아래와 같습니다",
    "dtmslgVipRule11" : "10. 이번 이벤트의 최종 해석권은 \${gameName} 운영팀에 있습니다.",
    "dtmslgType10010" : "일일 특혜",
    "dtmslgType10020" : "한정 공급",
    "dtmslgType10030" : "영웅",
    "dtmslgType10040" : "전투 장비",
    "dtmslgType10050" : "룬",
    "dtmslgType10060" : "토템",
    "dtmslgType10070" : "성석",
    "dtmslgType10080" : "드래곤",
    "dtmslgType10090" : "자원",
    "dtmslgType10100" : "건설 연구",
    "dtmslgType10110" : "희귀 상품",
    "dtmslgType10120" : "운명의 무장",
    "dtmslgType10130" : "다이아",
    "dtmslgType10140" : "상품권",
    "dtmslgType2" : "이벤트 패키지",
    "dtmslgType3" : "혜택 센터",
    "dtmslgType4" : "패키지 발동",
    "dtmslgType5" : "메인 화면 패키지",
    "dtmslgType20010" : "일의 금요일 패키지",
    "dtmslgType20021" : "5일 선물",
    "dtmslgTypeother" : "Other",
    "rightsIntro" : "",
    "213RightsIntro": "VIP 포인트 이벤트 기능 개편으로 기존 이벤트가 종료됩니다.<br/>\n" +
        "기존 VIP 포인트 이벤트에서 획득한 혜택 티켓은 유효기간이 초과되지 않도록 사용해 주시기 바랍니다.<br/>\n" +
        "종료 시간: 2024-08-19 08:00:00(utc)<br/>\n" +
        "이벤트 종료 후, VIP 센터에서 더 많은 혜택을 경험하실 수 있습니다:<br/>\n" +
        "퀘스트를 클리어하고 포인트를 획득하여 혜택 티켓, 게임 아이템 등의 보상으로 교환할 수 있습니다! 그 외에도 VIP 전용 혜택, 포인트 뽑기 등 다양한 혜택 이벤트가 준비되어 있습니다.<br/>\n" +
        "기대해 주세요.",
    "263RightsIntro": "VIP 포인트 이벤트 기능 개편으로 기존 이벤트가 종료됩니다.<br/>\n" +
        "기존 VIP 포인트 이벤트에서 획득한 혜택 티켓은 유효기간이 초과되지 않도록 사용해 주시기 바랍니다.<br/>\n" +
        "종료 시간: 2024-09-28 00:00:00(utc)<br/>\n" +
        "이벤트 종료 후, VIP 센터에서 더 많은 혜택을 경험하실 수 있습니다:<br/>\n" +
        "퀘스트를 클리어하고 포인트를 획득하여 혜택 티켓, 게임 아이템 등의 보상으로 교환할 수 있습니다! 그 외에도 VIP 전용 혜택, 포인트 뽑기 등 다양한 혜택 이벤트가 준비되어 있습니다.<br/>\n" +
        "기대해 주세요.",
    "goToRights" : "프리미엄 센터로 이동",
    "oldVipIntro" : "기존 VIP 포인트 이벤트에서 획득한 쿠폰은 유효기간 내에 사용해 주시기 바랍니다.",
    "pwa-20001" : "먼저 로그인하세요",
    "pwa-20002" : "파라미터 오류",
    "pwa-20003" : "캐릭터 미연동",
    "pwa-20004" : "보상 지급에 실패했습니다. 다시 시도하거나 고객센터에 연락해 주세요",
    "pwa-20005" : "해당 선물을 이미 수령했습니다.",
    "pwa-20100" : "이벤트 기간이 아닙니다",
    "pwa-20101" : "이벤트 종료",
    "pwa-20102" : "보상 수령 기간이 아닙니다",
    "pwa-20103" : "보상 수령 기간 만료",
    "pwa-1001" : "잠시 후에 시도하세요",
    "pwaCommon" : "잠시 후 다시 시도해주세요",
    "zipCodeSwitchZipCode" : "Switch ZIP Code",
    "zipCodeState" : "state",
    "zipCodeRate" : "rate",
    "-" : "-",
    "officialStore": "공식 충전 센터",
    "headerSafeTip": "안전 보장 즉시 입찰 가능",
    "safeChecking": "... 결제 환경 검사 중",
    "safeChecked": "안전하니 안심하고 사용하셔도 됩니다.",
    "riskChecked": "위험이 있으니 주의하여 취급하시기 바랍니다.",
    "footerSafeTitle1": "안전",
    "footerSafeTitle2": "편리",
    "footerSafeTitle3": "혜택",
    "footerSafeTitle4": "효율적",
    "footerSafeContent1": "공식 충전 센터",
    "footerSafeContent2": "다양한 지불 방식 지원",
    "footerSafeContent3": "할인 혜택, 더 많은 기간 한정 혜택",
    "footerSafeContent4": "빠른 입찰",
    "limitedTimeActivityTitle" : "한정 혜택",
    "limitedTimeActivityTime" : "이벤트 시간:  \${startDate} - \${endDate}（UTC）",
    "limitedTimeActivityTaskProcess" : "(현재 \${curPay}/\${targetPay})",
    "limitedTimeActivityRateTips" : "(환율 변동의 이유로, 해당 페이지에 표시된 수치를 기준으로 하시기 바랍니다)",
    "limitedTimeActivityNotAchieve" : "미완료",
    "limitedTimeActivityClaim" : "수령",
    "limitedTimeActivityClaimed" : "수령 완료",
    "limitedTimeActivityTimeLeft" : "남은 시간: \${days}d \${hours}:\${minutes}:\${seconds}",
    "limitedTimeActivityRecord" : "수령 기록",
    "limitedTimeActivityAward" : "보상",
    "limitedTimeActivityGotTime" : "수령 시간",
    "limitedTimeActivityGotRole" : "수령 캐릭터",
    "limitedTimeActivityRule" : "이벤트 규칙",
    "limitedTimeActivity285Rule1" : "1.이벤트 시간:  \${startDate} - \${endDate}（UTC）",
    "limitedTimeActivity285Rule2" : "2.이벤트 기간 동안 기간 한정 임무를 완료하면 보상을 받을 수 있습니다. 임무는 매주 임무와 매월 임무로 나뉩니다:",
    "limitedTimeActivity285Rule3" : "(1) 매주 임무: 매 계정당 1회만 완료 가능하며, 매주 월요일 0시에 초기화됩니다.",
    "limitedTimeActivity285Rule4" : "매주 로그인 임무: 제한 시간 내에 공식 웹사이트 충전 페이지에 1회 로그인하세요.",
    "limitedTimeActivity285Rule5" : "임의 금액 1회 충전 완료: 제한 시간 내에 공식 웹사이트 충전 페이지에서 임의 금액으로 1회 충전을 완료하면 임무가 완료됩니다.",
    "limitedTimeActivity285Rule6" : "(2)매월 임무: 각 계정당 1회만 완료 가능하며, 매월 1일 0시에 초기화됩니다.",
    "limitedTimeActivity285Rule7" : "로그인 임무: 제한 시간 내에 공식 웹사이트 충전 페이지에 1회 로그인하세요.",
    "limitedTimeActivity285Rule8" : "누적 충전 임무: 제한 시간 내에 공식 웹사이트 충전 페이지에서 임무 단계에 도달할 때까지 누적 충전을 하면 1회 보상을 받을 수 있습니다.",
    "limitedTimeActivity285Rule9" : "주의: 이벤트 기간에 환율 변동의 가능성이 존재하므로, 충전 금액은 페이지에 표시된 금액을 기준으로 하시기 바랍니다.",
    "limitedTimeActivity285Rule10" : "3. 보상을 받기 전에 먼저 보상을 받을 캐릭터를 선택해야 합니다. 보상 수령 후 게임 내에서 보상을 확인하세요.",
    "limitedTimeActivityClaimAward" : "보상 수령",
    "limitedTimeActivityConfirmGot" : "수령 확인",
    "limitedTimeActivityGetSucc" : "수령 성공",
    "limitedTimeActivityGetFail" : "수령 실패, 잠시 후 다시 시도하거나 고객센터에 문의하세요",
    "limitedTimeActivityFrequent" : "빈번하게 조작하지 마세요",
    "limitedTimeActivityLoginFirst" : "우선 로그인을 해 주세요",
    "limitedTimeActivityWrongParam" : "파라미터 오류",
    "limitedTimeActivityOverTips" : "이벤트가 만료되었습니다. 페이지를 새로고침하세요.",
    "preRightsIntro" : "VIP 포인트 이벤트 기능 개편으로 기존 이벤트가 종료됩니다.<br/>종료 시간: \${offLineDate}<br/>기존 VIP 포인트 이벤트에서 획득한 혜택 티켓은 유효기간이 초과되지 않도록 사용해 주시기 바랍니다.<br/>이벤트 종료 후, VIP 센터에서 더 많은 혜택을 경험하실 수 있습니다:<br/>퀘스트를 클리어하고 포인트를 획득하여 혜택 티켓, 게임 아이템 등의 보상으로 교환할 수 있습니다! 그 외에도 VIP 전용 혜택, 포인트 뽑기 등 다양한 혜택 이벤트가 준비되어 있습니다.<br/>기대해 주세요.",
    "riskTipTitle" : "사기 및 불량 행위에 주의하세요!",
    "riskTipContent" : "안녕하세요.\n\n현재 일부 유저가 게임의 질서와 공정성을 해치는 불량 행위를 하고 있음을 발견했습니다. 자주 발생하는 사례는 다음과 같습니다.\n\n1. 불법 광고 게시: 채팅 등의 경로를 통해 불법 자원 거래, 불법 대리 충전 등의 광고를 게시하는 행위\n2. 치트 또는 스크립트 사용: 게임 내에서 치트나 스크립트 등의 기술적 수단을 이용해 불법적으로 대량의 자원을 획득하는 행위\n3. 불법 초대: 채팅 시 게임 내용과 무관한 불법 초대를 발송해 게임 외부 경로(예: Line, Discord)를 통한 연락을 유도하는 행위\n4. 불법 대리 충전: 저가 충전 할인을 미끼로 비공식 충전을 유도하는 행위\n5. 기타 사기 행위: 운영진을 사칭하는 등의 사기 행위\n\n여러분의 재산과 개인정보를 보호하고, 불량 행위 및 사기 정보에 속지 않도록 주의하시기 바랍니다. 상기 불량 행위에는 많은 위험이 동반되며, 계정 도용뿐만 아니라 사기 행위에도 연루될 수 있습니다. 저희는 불법 행위로 인한 손실에 대해서 그 어떠한 보상도 지원해 드리지 않습니다.\n\n불량 행위를 한 계정에 대해서는 규칙 위반 정도 및 피해 영향 범위에 따라 경고, 불법 수익 회수, 일시적 또는 영구적 게임 계정 정지 등의 조치를 취할 것입니다. 게임 내에서 의심스러운 행위를 발견하시면 고객센터로 신고해 주시기 바랍니다. 신속히 확인하고 적절한 조치를 취하겠습니다. 감사합니다.",
    "linkValid": "링크가 만료되었습니다",
    "-" : "-",
    "accountLabel": "계정",
    "passwordLabel": "비밀번호",
    "confirmPasswordLabel": "비밀번호 확인",
    "confirmDeleteTitle" : "게임 계정 및 계정 내 모든 캐릭터를 삭제하시겠습니까?",
    "confirmDeleteYes" : "네, 게임 계정과 계정 내 모든 캐릭터를 삭제하겠습니다.",
    "selectGame" : "게임을 선택하세요.",
    "confirmDeleteNo" : "아니요, 특정 캐릭터만 삭제하고 게임 계정은 유지하겠습니다.",
    "delTermsTitle" : "계정 삭제 조건 및 주의사항을 꼭 읽어 주세요.",
    "delCondTitle" : "1. 계정 삭제 조건",
    "delCond1" : "(1) 해당 게임 계정 및 관련 게임 캐릭터는 본인이 등록 및 사용한 것이어야 합니다. <span>신청 전에 계정에 로그인해 주세요.</span> 계정에 로그인할 수 없는 경우에는 [계정 찾기]를 진행해 주세요.",
    "delCond2" : "(2) 해당 게임 계정 및 관련 게임 캐릭터는 <span>어떠한 보안 위험이 없어야 합니다.</span> 여기에는 처리되지 않은 불만, 신고, 조사, 중재, 소송 등과 피불만, 피신고, 피조사, 피중재, 피소송 등이 포함되지만, 이에 국한되지는 않습니다.",
    "delCond3" : "(3) 해당 게임 계정 및 관련 게임 캐릭터에는 <span>정산 대기 중인 미지급 항목이 없어야 합니다.</span> 여기에는 환불 미정산, 구독 미취소 등이 포함되지만, 이에 국한되지는 않습니다.",
    "delNoticeTitle" : "2. 계정 삭제 주의 사항",
    "delNotice1" : "(1) 귀하가 삭제 신청한 것은 해당 게임 계정 및 관련 게임 캐릭터로, <span>삭제가 완료되면 게임에 로그인할 수 없고 계정을 복구할 수도 없습니다.</span>",
    "delNotice2" : "(2) <span>먼저 귀하의 계정 및 관련 캐릭터의 게임 내 자산을 정산해 주시기 바랍니다.</span> 여기에는 게임 아이템, 게임 코인, 게임 내 구독 등이 포함되지만, 이에 국한되지는 않습니다. 삭제가 완료되면 게임 내 자산은 모두 삭제되며, 게임 서비스 종료 후에는 삭제된 계정 및 관련 캐릭터에 대한 환불이 이루어지지 않습니다.",
    "delNotice3" : "(3) 게임 계정 및 관련 캐릭터 정보가 삭제되면 해당 계정과 관련된 정보도 삭제되거나 익명화 처리됩니다. 단, 제3자 소셜 미디어의 로그인 정보(예: Facebook 연동 로그인 등)는 귀하가 스스로 연동을 해제하고 해당 소셜 플랫폼에서 정보를 삭제해 주셔야 합니다.",
    "delNotice4" : "(4) 귀하의 권익을 보장하기 위해 14일간의 보류 기한(일부 지역은 현지 법규에 따른 예외가 적용될 수 있습니다.), 즉 숙려 기간이 주어집니다. 숙려 기간 내에 고객센터에 문의하여 삭제 취소를 신청하실 수 있습니다.",
    "delNotice5" : "(5) 귀하의 계정 삭제 신청이 성공적으로 제출되면 즉시 계정을 정지하지만, 데이터 삭제에는 약 일주일 정도 소요됩니다. 계정이 완전히 삭제된 후에 즉시 이메일로 알려 드리겠습니다.",
    "delFormConfirm1" : "계정 삭제 조건 및 결과를 주의 깊게 읽고 숙지하였습니다.",
    "delFormConfirm2" : "삭제 신청한 계정에는 관련 미해결 신고 및 소송이 없습니다.",
    "delForm" : "<a class=\"account-delete-link\" href=\"javascript:;\"><계정 삭제 약관></a>을 읽고 동의합니다.",
    "cannotDeleteMsgTitle" : "계정 삭제를 진행할 수 없습니다.",
    "cannotDeleteMsg1" : "귀하의 계정이 다음 조건을 충족하지 않아 계정 삭제를 진행할 수 없습니다:",
    "cannotDeleteMsg2" : "귀하의 문의 사항이 처리되지 않은 것으로 확인되었습니다. 고객 문의가 완료된 후 다시 신청해 주시기 바랍니다.",
    "cannotDeleteMsg3" : "미정산된 환불 금액이 있습니다. 환불금을 완납한 후 계정 삭제를 신청해 주시기 바랍니다.",
    "cannotDeleteMsg4" : "다른 유저의 불만 또는 신고를 받고 있는 것으로 확인되었습니다. 고객 문의 처리 후에 다시 신청해 주시기 바랍니다.",
    "formCompleted" : "문의 작성 완료",
    "formCheckMsg1" : "문의가 작성 완료되었습니다. 고객센터 담당자의 심사 후 회신을 기다려 주시기 바랍니다.",
    "formCheckMsg2" : "<span class=\"account-delete-link\">[내 티켓]</span>에서 문의 처리 진행도를 확인하실 수 있습니다.",
    "delEmailMsg1" : "삭제가 완료된 후 이메일로 알려드릴까요?",
    "delEmailMsg2" : "계정 삭제 시 처리해야 할 데이터가 많아 완전히 삭제되기까지 약 일주일 정도 소요됩니다. 완전히 삭제된 후 이메일로 알려드리길 원하시나요? \n",
    "delEmailMsg3" : "작성해 주신 이메일 주소는 알림 용도로만 사용되며, 다른 용도로는 사용되지 않습니다.",
    "delEmailConfirmYes" : "예, 이메일로 알려 주세요.",
    "delEmailFill" : "알림 받을 이메일 주소를 입력해 주세요.",
    "delEmailConfirmNo" : "아니요, 이메일 알림은 필요 없습니다.",
    "delCoolMsg1" : "14일 숙려 기간을 선택하시겠습니까?",
    "delCoolMsg2" : "14일 숙려 기간 동안에는 계정이 정지되지만 언제든지 삭제를 취소할 수 있습니다. 14일 후 취소하지 않으시면 계정이 삭제되어 복구할 수 없습니다.",
    "delCoolMsg3" : "숙려 기간이 필요 없다고 선택하시면 신청 완료 후 바로 계정 삭제가 실행되며 계정을 복구할 수 없습니다.",
    "delCoolConfirmYes" : "예, 14일 숙려 기간을 두고 싶습니다.",
    "delCoolConfirmNo" : "아니요, 지금 삭제하고 싶습니다.",
    "delSecondCheckMsg1" : "계정의 모든 내용을 처리하고 지금 계정 쿨링오프 기간을 실행하시겠습니까? 실행 후에는 계정에 접속할 수 없습니다.",
    "delSecondCheckConfirmYes" : "네, 바로 시작하겠습니다.",
    "delResMsg1" : "귀하의 계정 삭제 신청이 제출되었으며, 다음 계정은 정지되어 접속할 수 없습니다:",
    "gameName" : "게임명:",
    "gameAccount" : "게임 계정:",
    "delResMsg2" : "<span>스크린샷을 찍고 위의 계정 정보를 복사하세요. 쿨링오프 기간 내에 계정을 복구해야 하는 경우 이것이 유일한 증빙 자료입니다.</span>",
    "delResMsg3" : "쿨링오프 기간은 총 14일입니다. 카운트다운:",
    "delResMsg4" : "쿨링오프 기간 내에 삭제 신청을 취소하려면 아래 [고객센터 문의]를 클릭하세요.",
    "copyAccountInfo" : "계정 정보 복사",
    "delResMsg5" : "계정 삭제 신청을 완료하셨으며, 현재 계정은 삭제 중에 있어 지금부터 로그인이 불가능합니다.",
    "delResMsg6" : "계정 삭제는 처리해야 할 데이터가 많아 시간이 소요됩니다. 계정 흔적이 즉시 삭제되지는 않지만, 약 일주일 내에 처리가 완료될 예정입니다.",
    "delResMsg7" : "이전에 알림 이메일 주소를 입력하신 경우, 지정하신 이메일로 메일을 발송해 드리겠습니다.",
    "delResMsg8" : "게임에 다시 로그인하고 싶으시다면 새 계정을 생성하여 로그인하실 수 있습니다.",
    "appleOption" : "App Store",
    "googleOption" : "Google Play",
    "otherOption" : "다른 채널",
    "itemWrong" : "해당 항목의 입력이 잘못되었습니다. 다시 입력해 주세요.",
    "delRegisterTime" : "가입 시간",
    "delDevice" : "자주 사용하는 기종",
    "delIp" : "자주 사용하는 IP",
    "delHistoryPayChannel" : "역사적 충전 채널",
    "delHistoryPayOrder" : "과거 결제 주문 번호",
    "delDeleteReason" : "계정 삭제 이유",
    "delPrevStep" : "이전",
    "delNextStep" : "다음",
    "delSecondCheckMsg2" : "계정의 모든 내용을 처리하고 지금 계정을 삭제하시겠습니까? 삭제 후에는 계정에 접속할 수 없습니다.",
    "pleaseFillIn" : "다음 정보를 입력해 주세요.",
    switchNewVersion: '결제 플랫폼',
    switchNewVersionPlatform: '새 버전으로 전환',
    updateVersionPopupContent: '원활한 게임 성능과 향후 새로운 기능 지원을 위해, 기기 시스템을 업그레이드하여 보다 안정적인 실행 경험과 호환성 최적화를 누리시길 권장합니다.',
    selectTopupTips:"90%의 유저가 공식 충전 센터를 선택했습니다",
    chuzhi: "충전",
    selectMethods: "결제 수단",
    landscapeTip2: "더 나은 경험을 위해 휴대폰을 세로 모드로 회전해 주세요",
    v3LaunchFromDesktopAndRewardToMailbox: '바탕화면에서 실행해 주세요\n캐릭터 선택 시 보상은 우편함으로 지급됩니다',
    ckoNotAvailable: '결제 서비스 오류가 발생했습니다. 나중에 다시 시도해 주세요.',
    ckoSubmitFail: '결제에 실패했습니다. 정보를 확인하시거나 다른 카드로 결제해 주세요. 이미 결제가 이루어진 경우 원래 결제 수단으로 환불됩니다.',
    gotoFinish: '진행',
    inAppPurchase: '앱 내 구매',
}